export interface IndustryCode {
  id: string;
  name: string;
  children?: IndustryCode[];
}

export function findIndustryCodeDeep(
  codes: IndustryCode[],
  targetId: string,
): IndustryCode | undefined {
  for (const code of codes) {
    if (code.id === targetId) {
      return code;
    }
    if (code.children) {
      const found = findIndustryCodeDeep(code.children, targetId);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
}

export const industryCodes: IndustryCode[] = [
  {
    id: "A",
    name: "LANDBRUG, JAGT, SKOVBRUG OG FISKERI",
    children: [
      {
        id: "1",
        name: "Plante- og husdyravl, jagt og serviceydelser i forbindelse hermed",
        children: [
          {
            id: "01.1",
            name: "Dyrkning af etårige afgrøder",
            children: [
              {
                id: "01.11",
                name: "Dyrkning af korn (undtagen ris), bælgfrugter og olieholdige frø",
                children: [
                  {
                    id: "011100",
                    name: "Dyrkning af korn (undtagen ris), bælgfrugter og olieholdige frø",
                  },
                ],
              },
              {
                id: "01.12",
                name: "Dyrkning af ris",
                children: [
                  {
                    id: "011200",
                    name: "Dyrkning af ris",
                  },
                ],
              },
              {
                id: "01.13",
                name: "Dyrkning af grøntsager og meloner, rødder og rodknolde",
                children: [
                  {
                    id: "011300",
                    name: "Dyrkning af grøntsager og meloner, rødder og rodknolde",
                  },
                ],
              },
              {
                id: "01.14",
                name: "Dyrkning af sukkerrør",
                children: [
                  {
                    id: "011400",
                    name: "Dyrkning af sukkerrør",
                  },
                ],
              },
              {
                id: "01.15",
                name: "Dyrkning af tobak",
                children: [
                  {
                    id: "011500",
                    name: "Dyrkning af tobak",
                  },
                ],
              },
              {
                id: "01.16",
                name: "Dyrkning af tekstilplanter",
                children: [
                  {
                    id: "011600",
                    name: "Dyrkning af tekstilplanter",
                  },
                ],
              },
              {
                id: "01.19",
                name: "Dyrkning af andre etårige afgrøder",
                children: [
                  {
                    id: "011900",
                    name: "Dyrkning af andre etårige afgrøder",
                  },
                ],
              },
            ],
          },
          {
            id: "01.2",
            name: "Dyrkning af flerårige afgrøder",
            children: [
              {
                id: "01.21",
                name: "Dyrkning af druer",
                children: [
                  {
                    id: "012100",
                    name: "Dyrkning af druer",
                  },
                ],
              },
              {
                id: "01.22",
                name: "Dyrkning af tropiske og subtropiske frugter",
                children: [
                  {
                    id: "012200",
                    name: "Dyrkning af tropiske og subtropiske frugter",
                  },
                ],
              },
              {
                id: "01.23",
                name: "Dyrkning af citrusfrugter",
                children: [
                  {
                    id: "012300",
                    name: "Dyrkning af citrusfrugter",
                  },
                ],
              },
              {
                id: "01.24",
                name: "Dyrkning af kernefrugter og stenfrugter",
                children: [
                  {
                    id: "012400",
                    name: "Dyrkning af kernefrugter og stenfrugter",
                  },
                ],
              },
              {
                id: "01.25",
                name: "Dyrkning af andre træfrugter, bær og nødder",
                children: [
                  {
                    id: "012500",
                    name: "Dyrkning af andre træfrugter, bær og nødder",
                  },
                ],
              },
              {
                id: "01.26",
                name: "Dyrkning af olieholdige frugter",
                children: [
                  {
                    id: "012600",
                    name: "Dyrkning af olieholdige frugter",
                  },
                ],
              },
              {
                id: "01.27",
                name: "Dyrkning af planter til fremstilling af drikkevarer",
                children: [
                  {
                    id: "012700",
                    name: "Dyrkning af planter til fremstilling af drikkevarer",
                  },
                ],
              },
              {
                id: "01.28",
                name: "Dyrkning af krydderiplanter, aromaplanter og lægeplanter",
                children: [
                  {
                    id: "012800",
                    name: "Dyrkning af krydderiplanter, aromaplanter og lægeplanter",
                  },
                ],
              },
              {
                id: "01.29",
                name: "Dyrkning af andre flerårige afgrøder",
                children: [
                  {
                    id: "012900",
                    name: "Dyrkning af andre flerårige afgrøder",
                  },
                ],
              },
            ],
          },
          {
            id: "01.3",
            name: "Planteformering",
            children: [
              {
                id: "01.30",
                name: "Planteformering",
                children: [
                  {
                    id: "013000",
                    name: "Planteformering",
                  },
                ],
              },
            ],
          },
          {
            id: "01.4",
            name: "Husdyravl",
            children: [
              {
                id: "01.41",
                name: "Avl af malkekvæg",
                children: [
                  {
                    id: "014100",
                    name: "Avl af malkekvæg",
                  },
                ],
              },
              {
                id: "01.42",
                name: "Avl af andet kvæg og bøfler",
                children: [
                  {
                    id: "014200",
                    name: "Avl af andet kvæg og bøfler",
                  },
                ],
              },
              {
                id: "01.43",
                name: "Avl af heste og dyr af hestefamilien",
                children: [
                  {
                    id: "014300",
                    name: "Avl af heste og dyr af hestefamilien",
                  },
                ],
              },
              {
                id: "01.44",
                name: "Avl af kameler og dyr af kamelfamilien",
                children: [
                  {
                    id: "014400",
                    name: "Avl af kameler og dyr af kamelfamilien",
                  },
                ],
              },
              {
                id: "01.45",
                name: "Avl af får og geder",
                children: [
                  {
                    id: "014500",
                    name: "Avl af får og geder",
                  },
                ],
              },
              {
                id: "01.46",
                name: "Svineavl",
                children: [
                  {
                    id: "014610",
                    name: "Avl af smågrise",
                  },
                  {
                    id: "014620",
                    name: "Produktion af slagtesvin",
                  },
                ],
              },
              {
                id: "01.47",
                name: "Fjerkræavl",
                children: [
                  {
                    id: "014700",
                    name: "Fjerkræavl",
                  },
                ],
              },
              {
                id: "01.48",
                name: "Avl af andre dyr",
                children: [
                  {
                    id: "014800",
                    name: "Avl af andre dyr",
                  },
                ],
              },
            ],
          },
          {
            id: "01.5",
            name: "Blandet landbrugsdrift",
            children: [
              {
                id: "01.50",
                name: "Blandet landbrugsdrift",
                children: [
                  {
                    id: "015000",
                    name: "Blandet landbrugsdrift",
                  },
                ],
              },
            ],
          },
          {
            id: "01.6",
            name: "Støtteaktiviteter i forbindelse med landbrug og forarbejdning af afgrøder efter høst",
            children: [
              {
                id: "01.61",
                name: "Støtteaktiviteter i forbindelse med planteavl",
                children: [
                  {
                    id: "016100",
                    name: "Støtteaktiviteter i forbindelse med planteavl",
                  },
                ],
              },
              {
                id: "01.62",
                name: "Støtteaktiviteter i forbindelse med husdyravl",
                children: [
                  {
                    id: "016200",
                    name: "Støtteaktiviteter i forbindelse med husdyravl",
                  },
                ],
              },
              {
                id: "01.63",
                name: "Forarbejdning af afgrøder efter høst af frø/sædekorn til udsæd",
                children: [
                  {
                    id: "016300",
                    name: "Forarbejdning af afgrøder efter høst af frø/sædekorn til udsæd",
                  },
                ],
              },
            ],
          },
          {
            id: "01.7",
            name: "Jagt, fældefangst og serviceydelser i forbindelse hermed",
            children: [
              {
                id: "01.70",
                name: "Jagt, fældefangst og serviceydelser i forbindelse hermed",
                children: [
                  {
                    id: "017000",
                    name: "Jagt, fældefangst og serviceydelser i forbindelse hermed",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "2",
        name: "Skovbrug og skovning",
        children: [
          {
            id: "02.1",
            name: "Dyrkning af træer og andre skovbrugsaktiviteter",
            children: [
              {
                id: "02.10",
                name: "Dyrkning af træer og andre skovbrugsaktiviteter",
                children: [
                  {
                    id: "021000",
                    name: "Dyrkning af træer og andre skovbrugsaktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "02.2",
            name: "Skovning",
            children: [
              {
                id: "02.20",
                name: "Skovning",
                children: [
                  {
                    id: "022000",
                    name: "Skovning",
                  },
                ],
              },
            ],
          },
          {
            id: "02.3",
            name: "Indsamling af vildtvoksende forstmateriale, undtagen træer",
            children: [
              {
                id: "02.30",
                name: "Indsamling af vildtvoksende forstmateriale, undtagen træer",
                children: [
                  {
                    id: "023000",
                    name: "Indsamling af vildtvoksende forstmateriale, undtagen træer",
                  },
                ],
              },
            ],
          },
          {
            id: "02.4",
            name: "Støtteaktiviteter i forbindelse med skovbrug",
            children: [
              {
                id: "02.40",
                name: "Støtteaktiviteter i forbindelse med skovbrug",
                children: [
                  {
                    id: "024000",
                    name: "Støtteaktiviteter i forbindelse med skovbrug",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "3",
        name: "Fiskeri og akvakultur",
        children: [
          {
            id: "03.1",
            name: "Fiskeri",
            children: [
              {
                id: "03.11",
                name: "Havfiskeri",
                children: [
                  {
                    id: "031100",
                    name: "Havfiskeri",
                  },
                ],
              },
              {
                id: "03.12",
                name: "Ferskvandsfiskeri",
                children: [
                  {
                    id: "031200",
                    name: "Ferskvandsfiskeri",
                  },
                ],
              },
            ],
          },
          {
            id: "03.2",
            name: "Akvakultur",
            children: [
              {
                id: "03.21",
                name: "Havbrug",
                children: [
                  {
                    id: "032100",
                    name: "Havbrug",
                  },
                ],
              },
              {
                id: "03.22",
                name: "Ferskvandsbrug",
                children: [
                  {
                    id: "032200",
                    name: "Ferskvandsbrug",
                  },
                ],
              },
            ],
          },
          {
            id: "03.3",
            name: "Støtteaktiviteter i forbindelse med fiskeri og akvakultur",
            children: [
              {
                id: "03.30",
                name: "Støtteaktiviteter i forbindelse med fiskeri og akvakultur",
                children: [
                  {
                    id: "033000",
                    name: "Støtteaktiviteter i forbindelse med fiskeri og akvakultur",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "B",
    name: "RÅSTOFINDVINDING",
    children: [
      {
        id: "5",
        name: "Indvinding af kul og brunkul",
        children: [
          {
            id: "05.1",
            name: "Indvinding af stenkul",
            children: [
              {
                id: "05.10",
                name: "Indvinding af stenkul",
                children: [
                  {
                    id: "051000",
                    name: "Indvinding af stenkul",
                  },
                ],
              },
            ],
          },
          {
            id: "05.2",
            name: "Indvinding af brunkul",
            children: [
              {
                id: "05.20",
                name: "Indvinding af brunkul",
                children: [
                  {
                    id: "052000",
                    name: "Indvinding af brunkul",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "6",
        name: "Indvinding af råolie og naturgas",
        children: [
          {
            id: "06.1",
            name: "Indvinding af råolie",
            children: [
              {
                id: "06.10",
                name: "Indvinding af råolie",
                children: [
                  {
                    id: "061000",
                    name: "Indvinding af råolie",
                  },
                ],
              },
            ],
          },
          {
            id: "06.2",
            name: "Indvinding af naturgas",
            children: [
              {
                id: "06.20",
                name: "Indvinding af naturgas",
                children: [
                  {
                    id: "062000",
                    name: "Indvinding af naturgas",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "7",
        name: "Brydning af metalmalme",
        children: [
          {
            id: "07.1",
            name: "Brydning af jernmalm",
            children: [
              {
                id: "07.10",
                name: "Brydning af jernmalm",
                children: [
                  {
                    id: "071000",
                    name: "Brydning af jernmalm",
                  },
                ],
              },
            ],
          },
          {
            id: "07.2",
            name: "Brydning af ikke-jernholdige metalmalme",
            children: [
              {
                id: "07.21",
                name: "Brydning af uran- og thoriummalme",
                children: [
                  {
                    id: "072100",
                    name: "Brydning af uran- og thoriummalme",
                  },
                ],
              },
              {
                id: "07.29",
                name: "Brydning af andre ikke-jernholdige metalmalme",
                children: [
                  {
                    id: "072900",
                    name: "Brydning af andre ikke-jernholdige metalmalme",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "8",
        name: "Anden råstofindvinding",
        children: [
          {
            id: "08.1",
            name: "Brydning af sten og indvinding af sand og ler",
            children: [
              {
                id: "08.11",
                name: "Brydning af pyntesten, kalksten, gips, skifer mv.",
                children: [
                  {
                    id: "081100",
                    name: "Brydning af pyntesten, kalksten, gips, skifer mv.",
                  },
                ],
              },
              {
                id: "08.12",
                name: "Grus- og sandgravning og indvinding af ler og kaolin",
                children: [
                  {
                    id: "081200",
                    name: "Grus- og sandgravning og indvinding af ler og kaolin",
                  },
                ],
              },
            ],
          },
          {
            id: "08.9",
            name: "Råstofindvinding i.a.n.",
            children: [
              {
                id: "08.91",
                name: "Indvinding af mineraler til fremstilling af kemiske produkter og gødningsstoffer",
                children: [
                  {
                    id: "089100",
                    name: "Indvinding af mineraler til fremstilling af kemiske produkter og gødningsstoffer",
                  },
                ],
              },
              {
                id: "08.92",
                name: "Indvinding af tørv",
                children: [
                  {
                    id: "089200",
                    name: "Indvinding af tørv",
                  },
                ],
              },
              {
                id: "08.93",
                name: "Saltindvinding",
                children: [
                  {
                    id: "089300",
                    name: "Saltindvinding",
                  },
                ],
              },
              {
                id: "08.99",
                name: "Anden råstofindvinding i.a.n.",
                children: [
                  {
                    id: "089900",
                    name: "Anden råstofindvinding i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "9",
        name: "Støtteaktiviteter i forbindelse med råstofindvinding",
        children: [
          {
            id: "09.1",
            name: "Støtteaktiviteter i forbindelse med indvinding af råolie og naturgas",
            children: [
              {
                id: "09.10",
                name: "Støtteaktiviteter i forbindelse med indvinding af råolie og naturgas",
                children: [
                  {
                    id: "091000",
                    name: "Støtteaktiviteter i forbindelse med indvinding af råolie og naturgas",
                  },
                ],
              },
            ],
          },
          {
            id: "09.9",
            name: "Støtteaktiviteter i forbindelse med anden råstofindvinding",
            children: [
              {
                id: "09.90",
                name: "Støtteaktiviteter i forbindelse med anden råstofindvinding",
                children: [
                  {
                    id: "099000",
                    name: "Støtteaktiviteter i forbindelse med anden råstofindvinding",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "C",
    name: "FREMSTILLINGSAKTIVITETER",
    children: [
      {
        id: "10",
        name: "Fremstilling af fødevarer",
        children: [
          {
            id: "10.1",
            name: "Forarbejdning og konservering af kød og fremstilling af kødprodukter",
            children: [
              {
                id: "10.11",
                name: "Forarbejdning og konservering af kød, undtagen fjerkrækød",
                children: [
                  {
                    id: "101110",
                    name: "Forarbejdning af svinekød",
                  },
                  {
                    id: "101190",
                    name: "Forarbejdning af andet kød",
                  },
                ],
              },
              {
                id: "10.12",
                name: "Forarbejdning og konservering af fjerkrækød",
                children: [
                  {
                    id: "101200",
                    name: "Forarbejdning og konservering af fjerkrækød",
                  },
                ],
              },
              {
                id: "10.13",
                name: "Fremstilling af kød- og fjerkrækødprodukter",
                children: [
                  {
                    id: "101300",
                    name: "Fremstilling af kød- og fjerkrækødprodukter",
                  },
                ],
              },
            ],
          },
          {
            id: "10.2",
            name: "Forarbejdning og konservering af fisk, krebsdyr og bløddyr",
            children: [
              {
                id: "10.20",
                name: "Forarbejdning og konservering af fisk, krebsdyr og bløddyr",
                children: [
                  {
                    id: "102010",
                    name: "Fremstilling af fiskemel",
                  },
                  {
                    id: "102020",
                    name: "Forarbejdning og konservering af fisk, krebsdyr og bløddyr, undtagen fiskemel",
                  },
                ],
              },
            ],
          },
          {
            id: "10.3",
            name: "Forarbejdning og konservering af frugt og grøntsager",
            children: [
              {
                id: "10.31",
                name: "Forarbejdning og konservering af kartofler",
                children: [
                  {
                    id: "103100",
                    name: "Forarbejdning og konservering af kartofler",
                  },
                ],
              },
              {
                id: "10.32",
                name: "Fremstilling af frugt- og grøntsagssaft",
                children: [
                  {
                    id: "103200",
                    name: "Fremstilling af frugt- og grøntsagssaft",
                  },
                ],
              },
              {
                id: "10.39",
                name: "Anden forarbejdning og konservering af frugt og grøntsager",
                children: [
                  {
                    id: "103900",
                    name: "Anden forarbejdning og konservering af frugt og grøntsager",
                  },
                ],
              },
            ],
          },
          {
            id: "10.4",
            name: "Fremstilling af vegetabilske og animalske olier og fedtstoffer",
            children: [
              {
                id: "10.41",
                name: "Fremstilling af olier og fedtstoffer",
                children: [
                  {
                    id: "104100",
                    name: "Fremstilling af olier og fedtstoffer",
                  },
                ],
              },
              {
                id: "10.42",
                name: "Fremstilling af margarine o.lign. spiselige fedtstoffer",
                children: [
                  {
                    id: "104200",
                    name: "Fremstilling af margarine o.lign. spiselige fedtstoffer",
                  },
                ],
              },
            ],
          },
          {
            id: "10.5",
            name: "Fremstilling af mejeriprodukter og konsumis",
            children: [
              {
                id: "10.51",
                name: "Fremstilling af mejeriprodukter",
                children: [
                  {
                    id: "105100",
                    name: "Fremstilling af mejeriprodukter",
                  },
                ],
              },
              {
                id: "10.52",
                name: "Fremstilling af konsumis",
                children: [
                  {
                    id: "105200",
                    name: "Fremstilling af konsumis",
                  },
                ],
              },
            ],
          },
          {
            id: "10.6",
            name: "Fremstilling af mølleriprodukter, stivelse og stivelsesprodukter",
            children: [
              {
                id: "10.61",
                name: "Fremstilling af mølleriprodukter",
                children: [
                  {
                    id: "106100",
                    name: "Fremstilling af mølleriprodukter",
                  },
                ],
              },
              {
                id: "10.62",
                name: "Fremstilling af stivelse og stivelsesprodukter",
                children: [
                  {
                    id: "106200",
                    name: "Fremstilling af stivelse og stivelsesprodukter",
                  },
                ],
              },
            ],
          },
          {
            id: "10.7",
            name: "Fremstilling af bageri- og dejprodukter",
            children: [
              {
                id: "10.71",
                name: "Fremstilling af brød, fremstilling af friske kager, tærter mv.",
                children: [
                  {
                    id: "107110",
                    name: "Industriel fremstilling af brød og kager mv.",
                  },
                  {
                    id: "107120",
                    name: "Fremstilling af friske bageriprodukter",
                  },
                ],
              },
              {
                id: "10.72",
                name: "Fremstilling af tvebakker, kiks, konserverede kager, tærter mv.",
                children: [
                  {
                    id: "107200",
                    name: "Fremstilling af tvebakker, kiks, konserverede kager, tærter mv.",
                  },
                ],
              },
              {
                id: "10.73",
                name: "Fremstilling af dejprodukter",
                children: [
                  {
                    id: "107300",
                    name: "Fremstilling af dejprodukter",
                  },
                ],
              },
            ],
          },
          {
            id: "10.8",
            name: "Fremstilling af andre fødevarer",
            children: [
              {
                id: "10.81",
                name: "Fremstilling af sukker",
                children: [
                  {
                    id: "108100",
                    name: "Fremstilling af sukker",
                  },
                ],
              },
              {
                id: "10.82",
                name: "Fremstilling af kakao, chokolade og sukkervarer",
                children: [
                  {
                    id: "108200",
                    name: "Fremstilling af kakao, chokolade og sukkervarer",
                  },
                ],
              },
              {
                id: "10.83",
                name: "Forarbejdning af te og kaffe",
                children: [
                  {
                    id: "108300",
                    name: "Forarbejdning af te og kaffe",
                  },
                ],
              },
              {
                id: "10.84",
                name: "Fremstilling af smagspræparater og krydderier",
                children: [
                  {
                    id: "108400",
                    name: "Fremstilling af smagspræparater og krydderier",
                  },
                ],
              },
              {
                id: "10.85",
                name: "Fremstilling af færdigretter",
                children: [
                  {
                    id: "108500",
                    name: "Fremstilling af færdigretter",
                  },
                ],
              },
              {
                id: "10.86",
                name: "Fremstilling af homogeniserede produkter og diætmad",
                children: [
                  {
                    id: "108600",
                    name: "Fremstilling af homogeniserede produkter og diætmad",
                  },
                ],
              },
              {
                id: "10.89",
                name: "Fremstilling af andre fødevarer i.a.n.",
                children: [
                  {
                    id: "108900",
                    name: "Fremstilling af andre fødevarer i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "10.9",
            name: "Fremstilling af færdige foderblandinger",
            children: [
              {
                id: "10.91",
                name: "Fremstilling af færdige foderblandinger til landbrugsdyr",
                children: [
                  {
                    id: "109100",
                    name: "Fremstilling af færdige foderblandinger til landbrugsdyr",
                  },
                ],
              },
              {
                id: "10.92",
                name: "Fremstilling af færdige foderblandinger til kæledyr",
                children: [
                  {
                    id: "109200",
                    name: "Fremstilling af færdige foderblandinger til kæledyr",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "11",
        name: "Fremstilling af drikkevarer",
        children: [
          {
            id: "11.0",
            name: "Fremstilling af drikkevarer",
            children: [
              {
                id: "11.01",
                name: "Destillation, rektifikation og blanding af alkohol",
                children: [
                  {
                    id: "110100",
                    name: "Destillation, rektifikation og blanding af alkohol",
                  },
                ],
              },
              {
                id: "11.02",
                name: "Fremstilling af vin af druer",
                children: [
                  {
                    id: "110200",
                    name: "Fremstilling af vin af druer",
                  },
                ],
              },
              {
                id: "11.03",
                name: "Fremstilling af cider og andre gærede drikkevarer af frugt",
                children: [
                  {
                    id: "110300",
                    name: "Fremstilling af cider og andre gærede drikkevarer af frugt",
                  },
                ],
              },
              {
                id: "11.04",
                name: "Fremstilling af andre ikke-destillerede gærede drikkevarer",
                children: [
                  {
                    id: "110400",
                    name: "Fremstilling af andre ikke-destillerede gærede drikkevarer",
                  },
                ],
              },
              {
                id: "11.05",
                name: "Fremstilling af øl",
                children: [
                  {
                    id: "110500",
                    name: "Fremstilling af øl",
                  },
                ],
              },
              {
                id: "11.06",
                name: "Fremstilling af malt",
                children: [
                  {
                    id: "110600",
                    name: "Fremstilling af malt",
                  },
                ],
              },
              {
                id: "11.07",
                name: "Fremstilling af læskedrikke og vand på flaske",
                children: [
                  {
                    id: "110700",
                    name: "Fremstilling af læskedrikke og vand på flaske",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "12",
        name: "Fremstilling af tobaksvarer",
        children: [
          {
            id: "12.0",
            name: "Fremstilling af tobaksvarer",
            children: [
              {
                id: "12.00",
                name: "Fremstilling af tobaksvarer",
                children: [
                  {
                    id: "120000",
                    name: "Fremstilling af tobaksvarer",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "13",
        name: "Fremstilling af tekstiler",
        children: [
          {
            id: "13.1",
            name: "Forbehandling og spinding af tekstilfibre",
            children: [
              {
                id: "13.10",
                name: "Forbehandling og spinding af tekstilfibre",
                children: [
                  {
                    id: "131000",
                    name: "Forbehandling og spinding af tekstilfibre",
                  },
                ],
              },
            ],
          },
          {
            id: "13.2",
            name: "Vævning af tekstiler",
            children: [
              {
                id: "13.20",
                name: "Vævning af tekstiler",
                children: [
                  {
                    id: "132000",
                    name: "Vævning af tekstiler",
                  },
                ],
              },
            ],
          },
          {
            id: "13.3",
            name: "Efterbehandling af tekstiler",
            children: [
              {
                id: "13.30",
                name: "Efterbehandling af tekstiler",
                children: [
                  {
                    id: "133000",
                    name: "Efterbehandling af tekstiler",
                  },
                ],
              },
            ],
          },
          {
            id: "13.9",
            name: "Fremstilling af andre tekstiler",
            children: [
              {
                id: "13.91",
                name: "Fremstilling af trikotagestoffer",
                children: [
                  {
                    id: "139100",
                    name: "Fremstilling af trikotagestoffer",
                  },
                ],
              },
              {
                id: "13.92",
                name: "Fremstilling af tekstiler til husholdningsbrug og færdige boligtekstiler",
                children: [
                  {
                    id: "139200",
                    name: "Fremstilling af tekstiler til husholdningsbrug og færdige boligtekstiler",
                  },
                ],
              },
              {
                id: "13.93",
                name: "Fremstilling af gulvtæpper og -måtter",
                children: [
                  {
                    id: "139300",
                    name: "Fremstilling af gulvtæpper og -måtter",
                  },
                ],
              },
              {
                id: "13.94",
                name: "Fremstilling af reb, tovværk, sejlgarn og netstoffer",
                children: [
                  {
                    id: "139400",
                    name: "Fremstilling af reb, tovværk, sejlgarn og netstoffer",
                  },
                ],
              },
              {
                id: "13.95",
                name: "Fremstilling af fiberdug og varer af fiberdug",
                children: [
                  {
                    id: "139500",
                    name: "Fremstilling af fiberdug og varer af fiberdug",
                  },
                ],
              },
              {
                id: "13.96",
                name: "Fremstilling af andre tekniske og industrielle tekstiler",
                children: [
                  {
                    id: "139600",
                    name: "Fremstilling af andre tekniske og industrielle tekstiler",
                  },
                ],
              },
              {
                id: "13.99",
                name: "Fremstilling af andre tekstiler i.a.n.",
                children: [
                  {
                    id: "139900",
                    name: "Fremstilling af andre tekstiler i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "14",
        name: "Fremstilling af beklædningsartikler",
        children: [
          {
            id: "14.1",
            name: "Fremstilling af strikkede og hæklede beklædningsartikler",
            children: [
              {
                id: "14.10",
                name: "Fremstilling af strikkede og hæklede beklædningsartikler",
                children: [
                  {
                    id: "141000",
                    name: "Fremstilling af strikkede og hæklede beklædningsartikler",
                  },
                ],
              },
            ],
          },
          {
            id: "14.2",
            name: "Fremstilling af andre beklædningsartikler samt tilbehør",
            children: [
              {
                id: "14.21",
                name: "Fremstilling af yderbeklædning",
                children: [
                  {
                    id: "142100",
                    name: "Fremstilling af yderbeklædning",
                  },
                ],
              },
              {
                id: "14.22",
                name: "Fremstilling af underbeklædning",
                children: [
                  {
                    id: "142200",
                    name: "Fremstilling af underbeklædning",
                  },
                ],
              },
              {
                id: "14.23",
                name: "Fremstilling af arbejdsbeklædning",
                children: [
                  {
                    id: "142300",
                    name: "Fremstilling af arbejdsbeklædning",
                  },
                ],
              },
              {
                id: "14.24",
                name: "Fremstilling af beklædningsartikler af læder og pelsskind",
                children: [
                  {
                    id: "142400",
                    name: "Fremstilling af beklædningsartikler af læder og pelsskind",
                  },
                ],
              },
              {
                id: "14.29",
                name: "Fremstilling af andre beklædningsartikler samt tilbehør i.a.n.",
                children: [
                  {
                    id: "142900",
                    name: "Fremstilling af andre beklædningsartikler samt tilbehør i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "15",
        name: "Fremstilling af lædervarer og lignende varer af andre materialer",
        children: [
          {
            id: "15.1",
            name: "Garvning, farvning, beredning af læder og pelsskind",
            children: [
              {
                id: "15.11",
                name: "Garvning, beredning og farvning af læder og pelsskind",
                children: [
                  {
                    id: "151100",
                    name: "Garvning, beredning og farvning af læder og pelsskind",
                  },
                ],
              },
              {
                id: "15.12",
                name: "Fremstilling af tasker, kufferter, sadelmagervarer mv., uanset materialets art",
                children: [
                  {
                    id: "151200",
                    name: "Fremstilling af tasker, kufferter, sadelmagervarer mv., uanset materialets art",
                  },
                ],
              },
            ],
          },
          {
            id: "15.2",
            name: "Fremstilling af fodtøj",
            children: [
              {
                id: "15.20",
                name: "Fremstilling af fodtøj",
                children: [
                  {
                    id: "152000",
                    name: "Fremstilling af fodtøj",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "16",
        name: "Fremstilling af træ og varer af træ og kork, undtagen møbler",
        children: [
          {
            id: "16.1",
            name: "Udsavning og høvling af træ",
            children: [
              {
                id: "16.11",
                name: "Udsavning og høvling af træ",
                children: [
                  {
                    id: "161100",
                    name: "Udsavning og høvling af træ",
                  },
                ],
              },
              {
                id: "16.12",
                name: "Forarbejdning og færdigbearbejdning af træ",
                children: [
                  {
                    id: "161200",
                    name: "Forarbejdning og færdigbearbejdning af træ",
                  },
                ],
              },
            ],
          },
          {
            id: "16.2",
            name: "Fremstilling af varer af træ, kork, strå og flettematerialer",
            children: [
              {
                id: "16.21",
                name: "Fremstilling af finerplader og træbaserede plader",
                children: [
                  {
                    id: "162100",
                    name: "Fremstilling af finerplader og træbaserede plader",
                  },
                ],
              },
              {
                id: "16.22",
                name: "Fremstilling af sammensatte parketstave",
                children: [
                  {
                    id: "162200",
                    name: "Fremstilling af sammensatte parketstave",
                  },
                ],
              },
              {
                id: "16.23",
                name: "Fremstilling af bygningstømmer og snedkeriartikler i øvrigt",
                children: [
                  {
                    id: "162300",
                    name: "Fremstilling af bygningstømmer og snedkeriartikler i øvrigt",
                  },
                ],
              },
              {
                id: "16.24",
                name: "Fremstilling af træemballage",
                children: [
                  {
                    id: "162400",
                    name: "Fremstilling af træemballage",
                  },
                ],
              },
              {
                id: "16.25",
                name: "Fremstilling af døre og vinduer af træ",
                children: [
                  {
                    id: "162500",
                    name: "Fremstilling af døre og vinduer af træ",
                  },
                ],
              },
              {
                id: "16.26",
                name: "Fremstilling af fast brændsel på basis af vegetabilsk biomasse",
                children: [
                  {
                    id: "162600",
                    name: "Fremstilling af fast brændsel på basis af vegetabilsk biomasse",
                  },
                ],
              },
              {
                id: "16.27",
                name: "Færdigbearbejdning af trævarer",
                children: [
                  {
                    id: "162700",
                    name: "Færdigbearbejdning af trævarer",
                  },
                ],
              },
              {
                id: "16.28",
                name: "Fremstilling af andre trævarer og varer af kork, strå og flettematerialer",
                children: [
                  {
                    id: "162800",
                    name: "Fremstilling af andre trævarer og varer af kork, strå og flettematerialer",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "17",
        name: "Fremstilling af papir og papirvarer",
        children: [
          {
            id: "17.1",
            name: "Fremstilling af papirmasse, papir og pap",
            children: [
              {
                id: "17.11",
                name: "Fremstilling af papirmasse",
                children: [
                  {
                    id: "171100",
                    name: "Fremstilling af papirmasse",
                  },
                ],
              },
              {
                id: "17.12",
                name: "Fremstilling af papir og pap",
                children: [
                  {
                    id: "171200",
                    name: "Fremstilling af papir og pap",
                  },
                ],
              },
            ],
          },
          {
            id: "17.2",
            name: "Fremstilling af papir- og papvarer",
            children: [
              {
                id: "17.21",
                name: "Fremstilling af bølgepap, pap og emballage af papir og pap",
                children: [
                  {
                    id: "172100",
                    name: "Fremstilling af bølgepap, pap og emballage af papir og pap",
                  },
                ],
              },
              {
                id: "17.22",
                name: "Fremstilling af husholdningsartikler og hygiejneartikler samt toiletartikler af papir og pap",
                children: [
                  {
                    id: "172200",
                    name: "Fremstilling af husholdningsartikler og hygiejneartikler samt toiletartikler af papir og pap",
                  },
                ],
              },
              {
                id: "17.23",
                name: "Fremstilling af kontorartikler af papir",
                children: [
                  {
                    id: "172300",
                    name: "Fremstilling af kontorartikler af papir",
                  },
                ],
              },
              {
                id: "17.24",
                name: "Fremstilling af tapet",
                children: [
                  {
                    id: "172400",
                    name: "Fremstilling af tapet",
                  },
                ],
              },
              {
                id: "17.25",
                name: "Fremstilling af andre papir- og papvarer",
                children: [
                  {
                    id: "172500",
                    name: "Fremstilling af andre papir- og papvarer",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "18",
        name: "Trykning og reproduktion af indspillede medier",
        children: [
          {
            id: "18.1",
            name: "Trykning og serviceydelser i forbindelse hermed",
            children: [
              {
                id: "18.11",
                name: "Trykning af dagblade",
                children: [
                  {
                    id: "181100",
                    name: "Trykning af dagblade",
                  },
                ],
              },
              {
                id: "18.12",
                name: "Anden trykning",
                children: [
                  {
                    id: "181200",
                    name: "Anden trykning",
                  },
                ],
              },
              {
                id: "18.13",
                name: "Prepress- og premedia-arbejde",
                children: [
                  {
                    id: "181300",
                    name: "Prepress- og premedia-arbejde",
                  },
                ],
              },
              {
                id: "18.14",
                name: "Bogbinding og lignende serviceydelser",
                children: [
                  {
                    id: "181400",
                    name: "Bogbinding og lignende serviceydelser",
                  },
                ],
              },
            ],
          },
          {
            id: "18.2",
            name: "Reproduktion af indspillede medier",
            children: [
              {
                id: "18.20",
                name: "Reproduktion af indspillede medier",
                children: [
                  {
                    id: "182000",
                    name: "Reproduktion af indspillede medier",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "19",
        name: "Fremstilling af koks og raffinerede mineralolieprodukter",
        children: [
          {
            id: "19.1",
            name: "Fremstilling af koksovnsprodukter",
            children: [
              {
                id: "19.10",
                name: "Fremstilling af koksovnsprodukter",
                children: [
                  {
                    id: "191000",
                    name: "Fremstilling af koksovnsprodukter",
                  },
                ],
              },
            ],
          },
          {
            id: "19.2",
            name: "Fremstilling af raffinerede mineralolieprodukter og fossile brændstoffer",
            children: [
              {
                id: "19.20",
                name: "Fremstilling af raffinerede mineralolieprodukter og fossile brændstoffer",
                children: [
                  {
                    id: "192000",
                    name: "Fremstilling af raffinerede mineralolieprodukter og fossile brændstoffer",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "20",
        name: "Fremstilling af kemiske produkter",
        children: [
          {
            id: "20.1",
            name: "Fremstilling af basiskemikalier, gødningsstoffer og nitrogenprodukter, plast og syntetisk gummi i ubearbejdet form",
            children: [
              {
                id: "20.11",
                name: "Fremstilling af industrigasser",
                children: [
                  {
                    id: "201100",
                    name: "Fremstilling af industrigasser",
                  },
                ],
              },
              {
                id: "20.12",
                name: "Fremstilling af farvestoffer og pigmenter",
                children: [
                  {
                    id: "201200",
                    name: "Fremstilling af farvestoffer og pigmenter",
                  },
                ],
              },
              {
                id: "20.13",
                name: "Fremstilling af andre uorganiske basiskemikalier",
                children: [
                  {
                    id: "201300",
                    name: "Fremstilling af andre uorganiske basiskemikalier",
                  },
                ],
              },
              {
                id: "20.14",
                name: "Fremstilling af andre organiske basiskemikalier",
                children: [
                  {
                    id: "201400",
                    name: "Fremstilling af andre organiske basiskemikalier",
                  },
                ],
              },
              {
                id: "20.15",
                name: "Fremstilling af gødningsstoffer og nitrogenprodukter",
                children: [
                  {
                    id: "201500",
                    name: "Fremstilling af gødningsstoffer og nitrogenprodukter",
                  },
                ],
              },
              {
                id: "20.16",
                name: "Fremstilling af plast i ubearbejdet form",
                children: [
                  {
                    id: "201600",
                    name: "Fremstilling af plast i ubearbejdet form",
                  },
                ],
              },
              {
                id: "20.17",
                name: "Fremstilling af syntetisk gummi i ubearbejdet form",
                children: [
                  {
                    id: "201700",
                    name: "Fremstilling af syntetisk gummi i ubearbejdet form",
                  },
                ],
              },
            ],
          },
          {
            id: "20.2",
            name: "Fremstilling af pesticider, desinfektionsmidler og andre agrokemiske produkter",
            children: [
              {
                id: "20.20",
                name: "Fremstilling af pesticider, desinfektionsmidler og andre agrokemiske produkter",
                children: [
                  {
                    id: "202000",
                    name: "Fremstilling af pesticider, desinfektionsmidler og andre agrokemiske produkter",
                  },
                ],
              },
            ],
          },
          {
            id: "20.3",
            name: "Fremstilling af maling, lak og lignende overfladebehandlingsmidler, trykfarver samt tætningsmaterialer",
            children: [
              {
                id: "20.30",
                name: "Fremstilling af maling, lak og lignende overfladebehandlingsmidler, trykfarver samt tætningsmaterialer",
                children: [
                  {
                    id: "203000",
                    name: "Fremstilling af maling, lak og lignende overfladebehandlingsmidler, trykfarver samt tætningsmaterialer",
                  },
                ],
              },
            ],
          },
          {
            id: "20.4",
            name: "Fremstilling af vaske-, rengørings- og rensemidler samt poleremidler",
            children: [
              {
                id: "20.41",
                name: "Fremstilling af sæbe, rengørings- og rensemidler samt poleremidler",
                children: [
                  {
                    id: "204100",
                    name: "Fremstilling af sæbe, rengørings- og rensemidler samt poleremidler",
                  },
                ],
              },
              {
                id: "20.42",
                name: "Fremstilling af parfume, hårshampoo, tandpasta mv.",
                children: [
                  {
                    id: "204200",
                    name: "Fremstilling af parfume, hårshampoo, tandpasta mv.",
                  },
                ],
              },
            ],
          },
          {
            id: "20.5",
            name: "Fremstilling af andre kemiske produkter",
            children: [
              {
                id: "20.51",
                name: "Fremstilling af flydende biobrændstoffer",
                children: [
                  {
                    id: "205100",
                    name: "Fremstilling af flydende biobrændstoffer",
                  },
                ],
              },
              {
                id: "20.59",
                name: "Fremstilling af andre kemiske produkter i.a.n.",
                children: [
                  {
                    id: "205900",
                    name: "Fremstilling af andre kemiske produkter i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "20.6",
            name: "Fremstilling af kemofibre",
            children: [
              {
                id: "20.60",
                name: "Fremstilling af kemofibre",
                children: [
                  {
                    id: "206000",
                    name: "Fremstilling af kemofibre",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "21",
        name: "Fremstilling af farmaceutiske råvarer og farmaceutiske præparater",
        children: [
          {
            id: "21.1",
            name: "Fremstilling af farmaceutiske råvarer",
            children: [
              {
                id: "21.10",
                name: "Fremstilling af farmaceutiske råvarer",
                children: [
                  {
                    id: "211000",
                    name: "Fremstilling af farmaceutiske råvarer",
                  },
                ],
              },
            ],
          },
          {
            id: "21.2",
            name: "Fremstilling af farmaceutiske præparater",
            children: [
              {
                id: "21.20",
                name: "Fremstilling af farmaceutiske præparater",
                children: [
                  {
                    id: "212000",
                    name: "Fremstilling af farmaceutiske præparater",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "22",
        name: "Fremstilling af gummi- og plastprodukter",
        children: [
          {
            id: "22.1",
            name: "Fremstilling af gummiprodukter",
            children: [
              {
                id: "22.11",
                name: "Fremstilling og vulkanisering af gummidæk og fremstilling af gummislanger",
                children: [
                  {
                    id: "221100",
                    name: "Fremstilling og vulkanisering af gummidæk og fremstilling af gummislanger",
                  },
                ],
              },
              {
                id: "22.12",
                name: "Fremstilling af andre gummiprodukter",
                children: [
                  {
                    id: "221200",
                    name: "Fremstilling af andre gummiprodukter",
                  },
                ],
              },
            ],
          },
          {
            id: "22.2",
            name: "Fremstilling af plastprodukter",
            children: [
              {
                id: "22.21",
                name: "Fremstilling af plader, ark, rør og slanger samt profiler af plast",
                children: [
                  {
                    id: "222100",
                    name: "Fremstilling af plader, ark, rør og slanger samt profiler af plast",
                  },
                ],
              },
              {
                id: "22.22",
                name: "Fremstilling af plastemballage",
                children: [
                  {
                    id: "222200",
                    name: "Fremstilling af plastemballage",
                  },
                ],
              },
              {
                id: "22.23",
                name: "Fremstilling af døre og vinduer af plast",
                children: [
                  {
                    id: "222300",
                    name: "Fremstilling af døre og vinduer af plast",
                  },
                ],
              },
              {
                id: "22.24",
                name: "Fremstilling af bygningsartikler af plast",
                children: [
                  {
                    id: "222400",
                    name: "Fremstilling af bygningsartikler af plast",
                  },
                ],
              },
              {
                id: "22.25",
                name: "Forarbejdning og færdigbehandling af plastprodukter",
                children: [
                  {
                    id: "222500",
                    name: "Forarbejdning og færdigbehandling af plastprodukter",
                  },
                ],
              },
              {
                id: "22.26",
                name: "Fremstilling af andre plastprodukter",
                children: [
                  {
                    id: "222600",
                    name: "Fremstilling af andre plastprodukter",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "23",
        name: "Fremstilling af andre ikke-metalholdige mineralske produkter",
        children: [
          {
            id: "23.1",
            name: "Fremstilling af glas og glasprodukter",
            children: [
              {
                id: "23.11",
                name: "Fremstilling af planglas",
                children: [
                  {
                    id: "231100",
                    name: "Fremstilling af planglas",
                  },
                ],
              },
              {
                id: "23.12",
                name: "Formning og forarbejdning af planglas",
                children: [
                  {
                    id: "231200",
                    name: "Formning og forarbejdning af planglas",
                  },
                ],
              },
              {
                id: "23.13",
                name: "Fremstilling af flasker, drikkeglas mv.",
                children: [
                  {
                    id: "231300",
                    name: "Fremstilling af flasker, drikkeglas mv.",
                  },
                ],
              },
              {
                id: "23.14",
                name: "Fremstilling af glasfiber",
                children: [
                  {
                    id: "231400",
                    name: "Fremstilling af glasfiber",
                  },
                ],
              },
              {
                id: "23.15",
                name: "Fremstilling og bearbejdning af andet glas, herunder teknisk glas",
                children: [
                  {
                    id: "231500",
                    name: "Fremstilling og bearbejdning af andet glas, herunder teknisk glas",
                  },
                ],
              },
            ],
          },
          {
            id: "23.2",
            name: "Fremstilling af ildfaste produkter",
            children: [
              {
                id: "23.20",
                name: "Fremstilling af ildfaste produkter",
                children: [
                  {
                    id: "232000",
                    name: "Fremstilling af ildfaste produkter",
                  },
                ],
              },
            ],
          },
          {
            id: "23.3",
            name: "Fremstilling af byggematerialer af ler",
            children: [
              {
                id: "23.31",
                name: "Fremstilling af keramiske teglsten og gulvfliser",
                children: [
                  {
                    id: "233100",
                    name: "Fremstilling af keramiske teglsten og gulvfliser",
                  },
                ],
              },
              {
                id: "23.32",
                name: "Fremstilling af mursten, teglsten og byggematerialer af brændt ler",
                children: [
                  {
                    id: "233200",
                    name: "Fremstilling af mursten, teglsten og byggematerialer af brændt ler",
                  },
                ],
              },
            ],
          },
          {
            id: "23.4",
            name: "Fremstilling af andre porcelænsvarer og keramiske produkter",
            children: [
              {
                id: "23.41",
                name: "Fremstilling af keramiske husholdningsartikler og pyntegenstande",
                children: [
                  {
                    id: "234100",
                    name: "Fremstilling af keramiske husholdningsartikler og pyntegenstande",
                  },
                ],
              },
              {
                id: "23.42",
                name: "Fremstilling af keramiske sanitetsartikler",
                children: [
                  {
                    id: "234200",
                    name: "Fremstilling af keramiske sanitetsartikler",
                  },
                ],
              },
              {
                id: "23.43",
                name: "Fremstilling af keramiske isolatorer og isoleringsdele",
                children: [
                  {
                    id: "234300",
                    name: "Fremstilling af keramiske isolatorer og isoleringsdele",
                  },
                ],
              },
              {
                id: "23.44",
                name: "Fremstilling af andre keramiske produkter til teknisk brug",
                children: [
                  {
                    id: "234400",
                    name: "Fremstilling af andre keramiske produkter til teknisk brug",
                  },
                ],
              },
              {
                id: "23.45",
                name: "Fremstilling af andre keramiske produkter",
                children: [
                  {
                    id: "234500",
                    name: "Fremstilling af andre keramiske produkter",
                  },
                ],
              },
            ],
          },
          {
            id: "23.5",
            name: "Fremstilling af cement, kalk og gips",
            children: [
              {
                id: "23.51",
                name: "Fremstilling af cement",
                children: [
                  {
                    id: "235100",
                    name: "Fremstilling af cement",
                  },
                ],
              },
              {
                id: "23.52",
                name: "Fremstilling af kalk og gips",
                children: [
                  {
                    id: "235200",
                    name: "Fremstilling af kalk og gips",
                  },
                ],
              },
            ],
          },
          {
            id: "23.6",
            name: "Fremstilling af produkter af beton, cement og gips",
            children: [
              {
                id: "23.61",
                name: "Fremstilling af byggematerialer af beton",
                children: [
                  {
                    id: "236100",
                    name: "Fremstilling af byggematerialer af beton",
                  },
                ],
              },
              {
                id: "23.62",
                name: "Fremstilling af byggematerialer af gips",
                children: [
                  {
                    id: "236200",
                    name: "Fremstilling af byggematerialer af gips",
                  },
                ],
              },
              {
                id: "23.63",
                name: "Fremstilling af færdigblandet beton",
                children: [
                  {
                    id: "236300",
                    name: "Fremstilling af færdigblandet beton",
                  },
                ],
              },
              {
                id: "23.64",
                name: "Fremstilling af mørtel",
                children: [
                  {
                    id: "236400",
                    name: "Fremstilling af mørtel",
                  },
                ],
              },
              {
                id: "23.65",
                name: "Fremstilling af fibercement",
                children: [
                  {
                    id: "236500",
                    name: "Fremstilling af fibercement",
                  },
                ],
              },
              {
                id: "23.66",
                name: "Fremstilling af andre produkter af beton, cement og gips",
                children: [
                  {
                    id: "236600",
                    name: "Fremstilling af andre produkter af beton, cement og gips",
                  },
                ],
              },
            ],
          },
          {
            id: "23.7",
            name: "Tilhugning, tilskæring og færdigbearbejdning af sten",
            children: [
              {
                id: "23.70",
                name: "Tilhugning, tilskæring og færdigbearbejdning af sten",
                children: [
                  {
                    id: "237000",
                    name: "Tilhugning, tilskæring og færdigbearbejdning af sten",
                  },
                ],
              },
            ],
          },
          {
            id: "23.9",
            name: "Fremstilling af slibemidler og ikke-metalholdige mineralske produkter i.a.n.",
            children: [
              {
                id: "23.91",
                name: "Fremstilling af slibemidler",
                children: [
                  {
                    id: "239100",
                    name: "Fremstilling af slibemidler",
                  },
                ],
              },
              {
                id: "23.99",
                name: "Fremstilling af andre ikke-metalholdige mineralske produkter i.a.n.",
                children: [
                  {
                    id: "239910",
                    name: "Fremstilling af asfalt og tagpap",
                  },
                  {
                    id: "239990",
                    name: "Fremstilling af andre ikke-metalholdige mineralske produkter, bortset fra asfalt og tagpap",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "24",
        name: "Fremstilling af basismetaller",
        children: [
          {
            id: "24.1",
            name: "Fremstilling af råjern og råstål samt jernlegeringer",
            children: [
              {
                id: "24.10",
                name: "Fremstilling af råjern og råstål samt jernlegeringer",
                children: [
                  {
                    id: "241000",
                    name: "Fremstilling af råjern og råstål samt jernlegeringer",
                  },
                ],
              },
            ],
          },
          {
            id: "24.2",
            name: "Fremstilling af rør, hule profiler og tilhørende fittings af stål",
            children: [
              {
                id: "24.20",
                name: "Fremstilling af rør, hule profiler og tilhørende fittings af stål",
                children: [
                  {
                    id: "242000",
                    name: "Fremstilling af rør, hule profiler og tilhørende fittings af stål",
                  },
                ],
              },
            ],
          },
          {
            id: "24.3",
            name: "Fremstilling af andre produkter af den primære forarbejdning af stål",
            children: [
              {
                id: "24.31",
                name: "Fremstilling af stænger ved koldtrækning",
                children: [
                  {
                    id: "243100",
                    name: "Fremstilling af stænger ved koldtrækning",
                  },
                ],
              },
              {
                id: "24.32",
                name: "Fremstilling af stålbånd ved koldvalsning",
                children: [
                  {
                    id: "243200",
                    name: "Fremstilling af stålbånd ved koldvalsning",
                  },
                ],
              },
              {
                id: "24.33",
                name: "Koldbehandling",
                children: [
                  {
                    id: "243300",
                    name: "Koldbehandling",
                  },
                ],
              },
              {
                id: "24.34",
                name: "Fremstilling af tråd ved koldtrækning",
                children: [
                  {
                    id: "243400",
                    name: "Fremstilling af tråd ved koldtrækning",
                  },
                ],
              },
            ],
          },
          {
            id: "24.4",
            name: "Fremstilling af ædelmetaller og andre ikke-jernholdige metaller",
            children: [
              {
                id: "24.41",
                name: "Fremstilling af ædelmetaller",
                children: [
                  {
                    id: "244100",
                    name: "Fremstilling af ædelmetaller",
                  },
                ],
              },
              {
                id: "24.42",
                name: "Fremstilling af aluminium",
                children: [
                  {
                    id: "244200",
                    name: "Fremstilling af aluminium",
                  },
                ],
              },
              {
                id: "24.43",
                name: "Fremstilling af bly, zink og tin",
                children: [
                  {
                    id: "244300",
                    name: "Fremstilling af bly, zink og tin",
                  },
                ],
              },
              {
                id: "24.44",
                name: "Fremstilling af kobber",
                children: [
                  {
                    id: "244400",
                    name: "Fremstilling af kobber",
                  },
                ],
              },
              {
                id: "24.45",
                name: "Anden fremstilling af ikke-jernholdige metaller",
                children: [
                  {
                    id: "244500",
                    name: "Anden fremstilling af ikke-jernholdige metaller",
                  },
                ],
              },
              {
                id: "24.46",
                name: "Oparbejdning af nukleart brændsel",
                children: [
                  {
                    id: "244600",
                    name: "Oparbejdning af nukleart brændsel",
                  },
                ],
              },
            ],
          },
          {
            id: "24.5",
            name: "Støbning af metalprodukter",
            children: [
              {
                id: "24.51",
                name: "Støbning af jernprodukter",
                children: [
                  {
                    id: "245100",
                    name: "Støbning af jernprodukter",
                  },
                ],
              },
              {
                id: "24.52",
                name: "Støbning af stålprodukter",
                children: [
                  {
                    id: "245200",
                    name: "Støbning af stålprodukter",
                  },
                ],
              },
              {
                id: "24.53",
                name: "Støbning af letmetalprodukter",
                children: [
                  {
                    id: "245300",
                    name: "Støbning af letmetalprodukter",
                  },
                ],
              },
              {
                id: "24.54",
                name: "Støbning af andre ikke-jernholdige metalprodukter",
                children: [
                  {
                    id: "245400",
                    name: "Støbning af andre ikke-jernholdige metalprodukter",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "25",
        name: "Fremstilling af færdige metalprodukter, undtagen maskiner og udstyr",
        children: [
          {
            id: "25.1",
            name: "Fremstilling af metalkonstruktioner",
            children: [
              {
                id: "25.11",
                name: "Fremstilling af metalkonstruktioner og dele heraf",
                children: [
                  {
                    id: "251100",
                    name: "Fremstilling af metalkonstruktioner og dele heraf",
                  },
                ],
              },
              {
                id: "25.12",
                name: "Fremstilling af døre og vinduer af metal",
                children: [
                  {
                    id: "251200",
                    name: "Fremstilling af døre og vinduer af metal",
                  },
                ],
              },
            ],
          },
          {
            id: "25.2",
            name: "Fremstilling af tanke og beholdere af metal",
            children: [
              {
                id: "25.21",
                name: "Fremstilling af radiatorer, damp- og fyringskedler til centralvarmeanlæg",
                children: [
                  {
                    id: "252100",
                    name: "Fremstilling af radiatorer, damp- og fyringskedler til centralvarmeanlæg",
                  },
                ],
              },
              {
                id: "25.22",
                name: "Fremstilling af andre tanke og beholdere af metal",
                children: [
                  {
                    id: "252200",
                    name: "Fremstilling af andre tanke og beholdere af metal",
                  },
                ],
              },
            ],
          },
          {
            id: "25.3",
            name: "Fremstilling af våben og ammunition",
            children: [
              {
                id: "25.30",
                name: "Fremstilling af våben og ammunition",
                children: [
                  {
                    id: "253000",
                    name: "Fremstilling af våben og ammunition",
                  },
                ],
              },
            ],
          },
          {
            id: "25.4",
            name: "Smedning og valsning af metal samt pulvermetallurgi",
            children: [
              {
                id: "25.40",
                name: "Smedning og valsning af metal samt pulvermetallurgi",
                children: [
                  {
                    id: "254000",
                    name: "Smedning og valsning af metal samt pulvermetallurgi",
                  },
                ],
              },
            ],
          },
          {
            id: "25.5",
            name: "Overfladebehandling af metal",
            children: [
              {
                id: "25.51",
                name: "Overfladebehandling af metal",
                children: [
                  {
                    id: "255100",
                    name: "Overfladebehandling af metal",
                  },
                ],
              },
              {
                id: "25.52",
                name: "Varmebehandling af metal",
                children: [
                  {
                    id: "255200",
                    name: "Varmebehandling af metal",
                  },
                ],
              },
              {
                id: "25.53",
                name: "Maskinforarbejdning af metal",
                children: [
                  {
                    id: "255300",
                    name: "Maskinforarbejdning af metal",
                  },
                ],
              },
            ],
          },
          {
            id: "25.6",
            name: "Fremstilling af bestik, skære- og klipperedskaber, håndværktøj og diverse metalprodukter",
            children: [
              {
                id: "25.61",
                name: "Fremstilling af bestik, skære- og klipperedskaber",
                children: [
                  {
                    id: "256100",
                    name: "Fremstilling af bestik, skære- og klipperedskaber",
                  },
                ],
              },
              {
                id: "25.62",
                name: "Fremstilling af låse og hængsler",
                children: [
                  {
                    id: "256200",
                    name: "Fremstilling af låse og hængsler",
                  },
                ],
              },
              {
                id: "25.63",
                name: "Fremstilling af håndværktøj",
                children: [
                  {
                    id: "256300",
                    name: "Fremstilling af håndværktøj",
                  },
                ],
              },
            ],
          },
          {
            id: "25.9",
            name: "Fremstilling af andre færdige metalprodukter",
            children: [
              {
                id: "25.91",
                name: "Fremstilling af metaltønder og lignende beholdere",
                children: [
                  {
                    id: "259100",
                    name: "Fremstilling af metaltønder og lignende beholdere",
                  },
                ],
              },
              {
                id: "25.92",
                name: "Fremstilling af letmetalemballage",
                children: [
                  {
                    id: "259200",
                    name: "Fremstilling af letmetalemballage",
                  },
                ],
              },
              {
                id: "25.93",
                name: "Fremstilling af trådvarer, kæder og fjedre",
                children: [
                  {
                    id: "259300",
                    name: "Fremstilling af trådvarer, kæder og fjedre",
                  },
                ],
              },
              {
                id: "25.94",
                name: "Fremstilling af lukkeanordninger, bolte, skruer og møtrikker",
                children: [
                  {
                    id: "259400",
                    name: "Fremstilling af lukkeanordninger, bolte, skruer og møtrikker",
                  },
                ],
              },
              {
                id: "25.99",
                name: "Fremstilling af andre færdige metalprodukter i.a.n.",
                children: [
                  {
                    id: "259900",
                    name: "Fremstilling af andre færdige metalprodukter i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "26",
        name: "Fremstilling af computere, elektroniske og optiske produkter",
        children: [
          {
            id: "26.1",
            name: "Fremstilling af elektroniske komponenter og plader",
            children: [
              {
                id: "26.11",
                name: "Fremstilling af elektroniske komponenter",
                children: [
                  {
                    id: "261100",
                    name: "Fremstilling af elektroniske komponenter",
                  },
                ],
              },
              {
                id: "26.12",
                name: "Fremstilling af printplader o.lign.",
                children: [
                  {
                    id: "261200",
                    name: "Fremstilling af printplader o.lign.",
                  },
                ],
              },
            ],
          },
          {
            id: "26.2",
            name: "Fremstilling af computere og ydre enheder",
            children: [
              {
                id: "26.20",
                name: "Fremstilling af computere og ydre enheder",
                children: [
                  {
                    id: "262000",
                    name: "Fremstilling af computere og ydre enheder",
                  },
                ],
              },
            ],
          },
          {
            id: "26.3",
            name: "Fremstilling af kommunikationsudstyr",
            children: [
              {
                id: "26.30",
                name: "Fremstilling af kommunikationsudstyr",
                children: [
                  {
                    id: "263000",
                    name: "Fremstilling af kommunikationsudstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "26.4",
            name: "Fremstilling af elektronik til husholdninger",
            children: [
              {
                id: "26.40",
                name: "Fremstilling af elektronik til husholdninger",
                children: [
                  {
                    id: "264000",
                    name: "Fremstilling af elektronik til husholdninger",
                  },
                ],
              },
            ],
          },
          {
            id: "26.5",
            name: "Fremstilling af udstyr til måling og afprøvning samt ure",
            children: [
              {
                id: "26.51",
                name: "Fremstilling af instrumenter og udstyr til måling, afprøvning og navigation",
                children: [
                  {
                    id: "265100",
                    name: "Fremstilling af instrumenter og udstyr til måling, afprøvning og navigation",
                  },
                ],
              },
              {
                id: "26.52",
                name: "Fremstilling af ure",
                children: [
                  {
                    id: "265200",
                    name: "Fremstilling af ure",
                  },
                ],
              },
            ],
          },
          {
            id: "26.6",
            name: "Fremstilling af bestrålingsudstyr og elektromedicinsk og elektroterapeutisk apparatur",
            children: [
              {
                id: "26.60",
                name: "Fremstilling af bestrålingsudstyr og elektromedicinsk og elektroterapeutisk apparatur",
                children: [
                  {
                    id: "266010",
                    name: "Fremstilling af høreapparater og dele hertil",
                  },
                  {
                    id: "266090",
                    name: "Fremstilling af bestrålingsudstyr og elektromedicinsk og elektroterapeutisk udstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "26.7",
            name: "Fremstilling af optiske instrumenter, magnetiske og optiske medier og fotografisk udstyr",
            children: [
              {
                id: "26.70",
                name: "Fremstilling af optiske instrumenter, magnetiske og optiske medier og fotografisk udstyr",
                children: [
                  {
                    id: "267000",
                    name: "Fremstilling af optiske instrumenter, magnetiske og optiske medier og fotografisk udstyr",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "27",
        name: "Fremstilling af elektrisk udstyr",
        children: [
          {
            id: "27.1",
            name: "Fremstilling af elektriske motorer, generatorer, transformatorer og elektriske fordelings- og kontroltavler",
            children: [
              {
                id: "27.11",
                name: "Fremstilling af elektriske motorer, generatorer og transformatorer",
                children: [
                  {
                    id: "271100",
                    name: "Fremstilling af elektriske motorer, generatorer og transformatorer",
                  },
                ],
              },
              {
                id: "27.12",
                name: "Fremstilling af elektriske fordelings- og kontrolapparater",
                children: [
                  {
                    id: "271200",
                    name: "Fremstilling af elektriske fordelings- og kontrolapparater",
                  },
                ],
              },
            ],
          },
          {
            id: "27.2",
            name: "Fremstilling af batterier og akkumulatorer",
            children: [
              {
                id: "27.20",
                name: "Fremstilling af batterier og akkumulatorer",
                children: [
                  {
                    id: "272000",
                    name: "Fremstilling af batterier og akkumulatorer",
                  },
                ],
              },
            ],
          },
          {
            id: "27.3",
            name: "Fremstilling af ledninger og kabler og tilbehør hertil",
            children: [
              {
                id: "27.31",
                name: "Fremstilling af lyslederkabler",
                children: [
                  {
                    id: "273100",
                    name: "Fremstilling af lyslederkabler",
                  },
                ],
              },
              {
                id: "27.32",
                name: "Fremstilling af andre elektroniske og elektriske ledninger og kabler",
                children: [
                  {
                    id: "273200",
                    name: "Fremstilling af andre elektroniske og elektriske ledninger og kabler",
                  },
                ],
              },
              {
                id: "27.33",
                name: "Fremstilling af tilbehør til ledninger og kabler",
                children: [
                  {
                    id: "273300",
                    name: "Fremstilling af tilbehør til ledninger og kabler",
                  },
                ],
              },
            ],
          },
          {
            id: "27.4",
            name: "Fremstilling af belysningsartikler",
            children: [
              {
                id: "27.40",
                name: "Fremstilling af belysningsartikler",
                children: [
                  {
                    id: "274000",
                    name: "Fremstilling af belysningsartikler",
                  },
                ],
              },
            ],
          },
          {
            id: "27.5",
            name: "Fremstilling af husholdningsapparater",
            children: [
              {
                id: "27.51",
                name: "Fremstilling af elektriske husholdningsapparater",
                children: [
                  {
                    id: "275100",
                    name: "Fremstilling af elektriske husholdningsapparater",
                  },
                ],
              },
              {
                id: "27.52",
                name: "Fremstilling af ikke-elektriske husholdningsapparater",
                children: [
                  {
                    id: "275200",
                    name: "Fremstilling af ikke-elektriske husholdningsapparater",
                  },
                ],
              },
            ],
          },
          {
            id: "27.9",
            name: "Fremstilling af andet elektrisk udstyr",
            children: [
              {
                id: "27.90",
                name: "Fremstilling af andet elektrisk udstyr",
                children: [
                  {
                    id: "279000",
                    name: "Fremstilling af andet elektrisk udstyr",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "28",
        name: "Fremstilling af maskiner og udstyr i.a.n.",
        children: [
          {
            id: "28.1",
            name: "Fremstilling af maskiner til generelle formål",
            children: [
              {
                id: "28.11",
                name: "Fremstilling af motorer og turbiner, undtagen motorer til flyvemaskiner, motorkøretøjer og knallerter",
                children: [
                  {
                    id: "281100",
                    name: "Fremstilling af motorer og turbiner, undtagen motorer til flyvemaskiner, motorkøretøjer og knallerter",
                  },
                ],
              },
              {
                id: "28.12",
                name: "Fremstilling af hydraulisk udstyr",
                children: [
                  {
                    id: "281200",
                    name: "Fremstilling af hydraulisk udstyr",
                  },
                ],
              },
              {
                id: "28.13",
                name: "Fremstilling af andre pumper og kompressorer",
                children: [
                  {
                    id: "281300",
                    name: "Fremstilling af andre pumper og kompressorer",
                  },
                ],
              },
              {
                id: "28.14",
                name: "Fremstilling af andre haner og ventiler",
                children: [
                  {
                    id: "281400",
                    name: "Fremstilling af andre haner og ventiler",
                  },
                ],
              },
              {
                id: "28.15",
                name: "Fremstilling af lejer, tandhjul, tandhjulsudvekslinger og drivelementer",
                children: [
                  {
                    id: "281500",
                    name: "Fremstilling af lejer, tandhjul, tandhjulsudvekslinger og drivelementer",
                  },
                ],
              },
            ],
          },
          {
            id: "28.2",
            name: "Fremstilling af andre maskiner til generelle formål",
            children: [
              {
                id: "28.21",
                name: "Fremstilling af ovne, ildsteder og fyringsaggregater til boligopvarmning",
                children: [
                  {
                    id: "282100",
                    name: "Fremstilling af ovne, ildsteder og fyringsaggregater til boligopvarmning",
                  },
                ],
              },
              {
                id: "28.22",
                name: "Fremstilling af løfte- og håndteringsudstyr",
                children: [
                  {
                    id: "282200",
                    name: "Fremstilling af løfte- og håndteringsudstyr",
                  },
                ],
              },
              {
                id: "28.23",
                name: "Fremstilling af kontormaskiner og -udstyr, undtagen computere og ydre enheder",
                children: [
                  {
                    id: "282300",
                    name: "Fremstilling af kontormaskiner og -udstyr, undtagen computere og ydre enheder",
                  },
                ],
              },
              {
                id: "28.24",
                name: "Fremstilling af motordrevet håndværktøj",
                children: [
                  {
                    id: "282400",
                    name: "Fremstilling af motordrevet håndværktøj",
                  },
                ],
              },
              {
                id: "28.25",
                name: "Fremstilling af klimaanlæg, ikke til husholdningsbrug",
                children: [
                  {
                    id: "282500",
                    name: "Fremstilling af klimaanlæg, ikke til husholdningsbrug",
                  },
                ],
              },
              {
                id: "28.29",
                name: "Fremstilling af andre maskiner til generelle formål i.a.n.",
                children: [
                  {
                    id: "282900",
                    name: "Fremstilling af andre maskiner til generelle formål i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "28.3",
            name: "Fremstilling af landbrugs- og skovbrugsmaskiner",
            children: [
              {
                id: "28.30",
                name: "Fremstilling af landbrugs- og skovbrugsmaskiner",
                children: [
                  {
                    id: "283000",
                    name: "Fremstilling af landbrugs- og skovbrugsmaskiner",
                  },
                ],
              },
            ],
          },
          {
            id: "28.4",
            name: "Fremstilling af metalforarbejdende maskiner og maskinværktøj",
            children: [
              {
                id: "28.41",
                name: "Fremstilling af metalforarbejdende maskiner og maskinværktøj til bearbejdning af metal",
                children: [
                  {
                    id: "284100",
                    name: "Fremstilling af metalforarbejdende maskiner og maskinværktøj til bearbejdning af metal",
                  },
                ],
              },
              {
                id: "28.42",
                name: "Fremstilling af andet maskinværktøj",
                children: [
                  {
                    id: "284200",
                    name: "Fremstilling af andet maskinværktøj",
                  },
                ],
              },
            ],
          },
          {
            id: "28.9",
            name: "Fremstilling af andre maskiner til specielle formål",
            children: [
              {
                id: "28.91",
                name: "Fremstilling af maskiner til metallurgi",
                children: [
                  {
                    id: "289100",
                    name: "Fremstilling af maskiner til metallurgi",
                  },
                ],
              },
              {
                id: "28.92",
                name: "Fremstilling af maskiner til råstofindvindingsindustrien samt bygge- og anlæg",
                children: [
                  {
                    id: "289200",
                    name: "Fremstilling af maskiner til råstofindvindingsindustrien samt bygge- og anlæg",
                  },
                ],
              },
              {
                id: "28.93",
                name: "Fremstilling af maskiner til føde-, drikke- og tobaksvareindustrien",
                children: [
                  {
                    id: "289300",
                    name: "Fremstilling af maskiner til føde-, drikke- og tobaksvareindustrien",
                  },
                ],
              },
              {
                id: "28.94",
                name: "Fremstilling af maskiner til produktion af tekstiler, beklædningsartikler og læder",
                children: [
                  {
                    id: "289400",
                    name: "Fremstilling af maskiner til produktion af tekstiler, beklædningsartikler og læder",
                  },
                ],
              },
              {
                id: "28.95",
                name: "Fremstilling af maskiner til produktion af papir og pap",
                children: [
                  {
                    id: "289500",
                    name: "Fremstilling af maskiner til produktion af papir og pap",
                  },
                ],
              },
              {
                id: "28.96",
                name: "Fremstilling af maskiner til produktion af plast og gummi",
                children: [
                  {
                    id: "289600",
                    name: "Fremstilling af maskiner til produktion af plast og gummi",
                  },
                ],
              },
              {
                id: "28.97",
                name: "Fremstilling af maskiner til additiv fremstilling",
                children: [
                  {
                    id: "289700",
                    name: "Fremstilling af maskiner til additiv fremstilling",
                  },
                ],
              },
              {
                id: "28.99",
                name: "Fremstilling af øvrige maskiner til specielle formål i.a.n.",
                children: [
                  {
                    id: "289900",
                    name: "Fremstilling af øvrige maskiner til specielle formål i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "29",
        name: "Fremstilling af motorkøretøjer, påhængsvogne og sættevogne",
        children: [
          {
            id: "29.1",
            name: "Fremstilling af motorkøretøjer",
            children: [
              {
                id: "29.10",
                name: "Fremstilling af motorkøretøjer",
                children: [
                  {
                    id: "291000",
                    name: "Fremstilling af motorkøretøjer",
                  },
                ],
              },
            ],
          },
          {
            id: "29.2",
            name: "Fremstilling af karosserier til motorkøretøjer",
            children: [
              {
                id: "29.20",
                name: "Fremstilling af karosserier til motorkøretøjer",
                children: [
                  {
                    id: "292000",
                    name: "Fremstilling af karosserier til motorkøretøjer",
                  },
                ],
              },
            ],
          },
          {
            id: "29.3",
            name: "Fremstilling af reservedele og tilbehør til motorkøretøjer",
            children: [
              {
                id: "29.31",
                name: "Fremstilling af elektrisk og elektronisk udstyr til motorkøretøjer",
                children: [
                  {
                    id: "293100",
                    name: "Fremstilling af elektrisk og elektronisk udstyr til motorkøretøjer",
                  },
                ],
              },
              {
                id: "29.32",
                name: "Fremstilling af andre dele og tilbehør til motorkøretøjer",
                children: [
                  {
                    id: "293200",
                    name: "Fremstilling af andre dele og tilbehør til motorkøretøjer",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "30",
        name: "Fremstilling af andre transportmidler",
        children: [
          {
            id: "30.1",
            name: "Bygning af skibe og både",
            children: [
              {
                id: "30.11",
                name: "Bygning af civile skibe og flydende materiel",
                children: [
                  {
                    id: "301100",
                    name: "Bygning af civile skibe og flydende materiel",
                  },
                ],
              },
              {
                id: "30.12",
                name: "Bygning af både til fritid og sport",
                children: [
                  {
                    id: "301200",
                    name: "Bygning af både til fritid og sport",
                  },
                ],
              },
              {
                id: "30.13",
                name: "Bygning af militærfartøjer",
                children: [
                  {
                    id: "301300",
                    name: "Bygning af militærfartøjer",
                  },
                ],
              },
            ],
          },
          {
            id: "30.2",
            name: "Fremstilling af lokomotiver og andet rullende materiel til jernbaner og sporveje",
            children: [
              {
                id: "30.20",
                name: "Fremstilling af lokomotiver og andet rullende materiel til jernbaner og sporveje",
                children: [
                  {
                    id: "302000",
                    name: "Fremstilling af lokomotiver og andet rullende materiel til jernbaner og sporveje",
                  },
                ],
              },
            ],
          },
          {
            id: "30.3",
            name: "Fremstilling af luft- og rumfartøjer o.lign.",
            children: [
              {
                id: "30.31",
                name: "Fremstilling af civile luft- og rumfartøjer o.lign.",
                children: [
                  {
                    id: "303100",
                    name: "Fremstilling af civile luft- og rumfartøjer o.lign.",
                  },
                ],
              },
              {
                id: "30.32",
                name: "Fremstilling af militære luft- og rumfartøjer o.lign.",
                children: [
                  {
                    id: "303200",
                    name: "Fremstilling af militære luft- og rumfartøjer o.lign.",
                  },
                ],
              },
            ],
          },
          {
            id: "30.4",
            name: "Fremstilling af militære kampkøretøjer",
            children: [
              {
                id: "30.40",
                name: "Fremstilling af militære kampkøretøjer",
                children: [
                  {
                    id: "304000",
                    name: "Fremstilling af militære kampkøretøjer",
                  },
                ],
              },
            ],
          },
          {
            id: "30.9",
            name: "Fremstilling af transportmidler i.a.n.",
            children: [
              {
                id: "30.91",
                name: "Fremstilling af motorcykler",
                children: [
                  {
                    id: "309100",
                    name: "Fremstilling af motorcykler",
                  },
                ],
              },
              {
                id: "30.92",
                name: "Fremstilling af cykler og kørestole",
                children: [
                  {
                    id: "309200",
                    name: "Fremstilling af cykler og kørestole",
                  },
                ],
              },
              {
                id: "30.99",
                name: "Fremstilling af andre transportmidler i.a.n.",
                children: [
                  {
                    id: "309900",
                    name: "Fremstilling af andre transportmidler i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "31",
        name: "Fremstilling af møbler",
        children: [
          {
            id: "31.0",
            name: "Fremstilling af møbler",
            children: [
              {
                id: "31.00",
                name: "Fremstilling af møbler",
                children: [
                  {
                    id: "310000",
                    name: "Fremstilling af møbler",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "32",
        name: "Andre fremstillingsaktiviteter",
        children: [
          {
            id: "32.1",
            name: "Fremstilling af smykker, bijouteri og lignende varer",
            children: [
              {
                id: "32.11",
                name: "Prægning af mønter",
                children: [
                  {
                    id: "321100",
                    name: "Prægning af mønter",
                  },
                ],
              },
              {
                id: "32.12",
                name: "Fremstilling af smykker og lignende varer",
                children: [
                  {
                    id: "321200",
                    name: "Fremstilling af smykker og lignende varer",
                  },
                ],
              },
              {
                id: "32.13",
                name: "Fremstilling af bijouteri og lignende varer",
                children: [
                  {
                    id: "321300",
                    name: "Fremstilling af bijouteri og lignende varer",
                  },
                ],
              },
            ],
          },
          {
            id: "32.2",
            name: "Fremstilling af musikinstrumenter",
            children: [
              {
                id: "32.20",
                name: "Fremstilling af musikinstrumenter",
                children: [
                  {
                    id: "322000",
                    name: "Fremstilling af musikinstrumenter",
                  },
                ],
              },
            ],
          },
          {
            id: "32.3",
            name: "Fremstilling af sportsudstyr",
            children: [
              {
                id: "32.30",
                name: "Fremstilling af sportsudstyr",
                children: [
                  {
                    id: "323000",
                    name: "Fremstilling af sportsudstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "32.4",
            name: "Fremstilling af spil og legetøj",
            children: [
              {
                id: "32.40",
                name: "Fremstilling af spil og legetøj",
                children: [
                  {
                    id: "324000",
                    name: "Fremstilling af spil og legetøj",
                  },
                ],
              },
            ],
          },
          {
            id: "32.5",
            name: "Fremstilling af medicinske og dentale instrumenter samt udstyr hertil",
            children: [
              {
                id: "32.50",
                name: "Fremstilling af medicinske og dentale instrumenter samt udstyr hertil",
                children: [
                  {
                    id: "325000",
                    name: "Fremstilling af medicinske og dentale instrumenter samt udstyr hertil",
                  },
                ],
              },
            ],
          },
          {
            id: "32.9",
            name: "Fremstillingsaktiviteter i.a.n.",
            children: [
              {
                id: "32.91",
                name: "Fremstilling af koste og børster",
                children: [
                  {
                    id: "329100",
                    name: "Fremstilling af koste og børster",
                  },
                ],
              },
              {
                id: "32.99",
                name: "Andre fremstillingsaktiviteter i.a.n.",
                children: [
                  {
                    id: "329900",
                    name: "Andre fremstillingsaktiviteter i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "33",
        name: "Reparation, vedligeholdelse og installation af maskiner og udstyr",
        children: [
          {
            id: "33.1",
            name: "Reparation og vedligeholdelse af færdige metalprodukter, maskiner og udstyr",
            children: [
              {
                id: "33.11",
                name: "Reparation og vedligeholdelse af færdige metalprodukter",
                children: [
                  {
                    id: "331100",
                    name: "Reparation og vedligeholdelse af færdige metalprodukter",
                  },
                ],
              },
              {
                id: "33.12",
                name: "Reparation og vedligeholdelse af maskiner",
                children: [
                  {
                    id: "331200",
                    name: "Reparation og vedligeholdelse af maskiner",
                  },
                ],
              },
              {
                id: "33.13",
                name: "Reparation og vedligeholdelse af elektronisk og optisk udstyr",
                children: [
                  {
                    id: "331300",
                    name: "Reparation og vedligeholdelse af elektronisk og optisk udstyr",
                  },
                ],
              },
              {
                id: "33.14",
                name: "Reparation og vedligeholdelse af elektrisk udstyr",
                children: [
                  {
                    id: "331400",
                    name: "Reparation og vedligeholdelse af elektrisk udstyr",
                  },
                ],
              },
              {
                id: "33.15",
                name: "Reparation og vedligeholdelse af civile skibe og både",
                children: [
                  {
                    id: "331500",
                    name: "Reparation og vedligeholdelse af civile skibe og både",
                  },
                ],
              },
              {
                id: "33.16",
                name: "Reparation og vedligeholdelse af civile luft- og rumfartøjer",
                children: [
                  {
                    id: "331600",
                    name: "Reparation og vedligeholdelse af civile luft- og rumfartøjer",
                  },
                ],
              },
              {
                id: "33.17",
                name: "Reparation og vedligeholdelse af andre civile transportmidler",
                children: [
                  {
                    id: "331700",
                    name: "Reparation og vedligeholdelse af andre civile transportmidler",
                  },
                ],
              },
              {
                id: "33.18",
                name: "Reparation og vedligeholdelse af militære kampkøretøjer, skibe, både og luft- og rumfartøjer",
                children: [
                  {
                    id: "331800",
                    name: "Reparation og vedligeholdelse af militære kampkøretøjer, skibe, både og luft- og rumfartøjer",
                  },
                ],
              },
              {
                id: "33.19",
                name: "Reparation og vedligeholdelse af andet udstyr",
                children: [
                  {
                    id: "331900",
                    name: "Reparation og vedligeholdelse af andet udstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "33.2",
            name: "Installation af industrimaskiner og -udstyr",
            children: [
              {
                id: "33.20",
                name: "Installation af industrimaskiner og -udstyr",
                children: [
                  {
                    id: "332000",
                    name: "Installation af industrimaskiner og -udstyr",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "D",
    name: "EL-, GAS- OG FJERNVARMEFORSYNING",
    children: [
      {
        id: "35",
        name: "El-, gas- og fjernvarmeforsyning",
        children: [
          {
            id: "35.1",
            name: "Elforsyning",
            children: [
              {
                id: "35.11",
                name: "Produktion af elektricitet fra ikke-vedvarende energikilder",
                children: [
                  {
                    id: "351100",
                    name: "Produktion af elektricitet fra ikke-vedvarende energikilder",
                  },
                ],
              },
              {
                id: "35.12",
                name: "Produktion af elektricitet fra vedvarende energikilder",
                children: [
                  {
                    id: "351200",
                    name: "Produktion af elektricitet fra vedvarende energikilder",
                  },
                ],
              },
              {
                id: "35.13",
                name: "Transmission af elektricitet",
                children: [
                  {
                    id: "351300",
                    name: "Transmission af elektricitet",
                  },
                ],
              },
              {
                id: "35.14",
                name: "Distribution af elektricitet",
                children: [
                  {
                    id: "351400",
                    name: "Distribution af elektricitet",
                  },
                ],
              },
              {
                id: "35.15",
                name: "Handel med elektricitet",
                children: [
                  {
                    id: "351510",
                    name: "Handel med elektricitet via ladestationer o. lign.",
                  },
                  {
                    id: "351590",
                    name: "Anden handel med elektricitet",
                  },
                ],
              },
              {
                id: "35.16",
                name: "Lagring af elektricitet",
                children: [
                  {
                    id: "351600",
                    name: "Lagring af elektricitet",
                  },
                ],
              },
            ],
          },
          {
            id: "35.2",
            name: "Produktion af gas og distribution af luftformige brændstoffer gennem rørledninger",
            children: [
              {
                id: "35.21",
                name: "Produktion af gas",
                children: [
                  {
                    id: "352100",
                    name: "Produktion af gas",
                  },
                ],
              },
              {
                id: "35.22",
                name: "Distribution af gas",
                children: [
                  {
                    id: "352200",
                    name: "Distribution af gas",
                  },
                ],
              },
              {
                id: "35.23",
                name: "Handel med gas gennem rørledninger",
                children: [
                  {
                    id: "352300",
                    name: "Handel med gas gennem rørledninger",
                  },
                ],
              },
              {
                id: "35.24",
                name: "Oplagring af gas i forbindelse med drift af forsyningsnet",
                children: [
                  {
                    id: "352400",
                    name: "Oplagring af gas i forbindelse med drift af forsyningsnet",
                  },
                ],
              },
            ],
          },
          {
            id: "35.3",
            name: "Fjernvarmeforsyning",
            children: [
              {
                id: "35.30",
                name: "Fjernvarmeforsyning",
                children: [
                  {
                    id: "353000",
                    name: "Fjernvarmeforsyning",
                  },
                ],
              },
            ],
          },
          {
            id: "35.4",
            name: "Mægler- og agentaktiviteter i forbindelse med forsyning af elektricitet og naturgas",
            children: [
              {
                id: "35.40",
                name: "Mægler- og agentaktiviteter i forbindelse med forsyning af elektricitet og naturgas",
                children: [
                  {
                    id: "354000",
                    name: "Mægler- og agentaktiviteter i forbindelse med forsyning af elektricitet og naturgas",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "E",
    name: "VANDFORSYNING",
    children: [
      {
        id: "36",
        name: "Vandforsyning",
        children: [
          {
            id: "36.0",
            name: "Vandforsyning",
            children: [
              {
                id: "36.00",
                name: "Vandforsyning",
                children: [
                  {
                    id: "360000",
                    name: "Vandforsyning",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "37",
        name: "Opsamling og behandling af spildevand",
        children: [
          {
            id: "37.0",
            name: "Opsamling og behandling af spildevand",
            children: [
              {
                id: "37.00",
                name: "Opsamling og behandling af spildevand",
                children: [
                  {
                    id: "370000",
                    name: "Opsamling og behandling af spildevand",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "38",
        name: "Indsamling, nyttiggørelse og bortskaffelse af affald",
        children: [
          {
            id: "38.1",
            name: "Indsamling af affald",
            children: [
              {
                id: "38.11",
                name: "Indsamling af ikke-farligt affald",
                children: [
                  {
                    id: "381100",
                    name: "Indsamling af ikke-farligt affald",
                  },
                ],
              },
              {
                id: "38.12",
                name: "Indsamling af farligt affald",
                children: [
                  {
                    id: "381200",
                    name: "Indsamling af farligt affald",
                  },
                ],
              },
            ],
          },
          {
            id: "38.2",
            name: "Nyttiggørelse af affald",
            children: [
              {
                id: "38.21",
                name: "Genindvinding af materialer",
                children: [
                  {
                    id: "382100",
                    name: "Genindvinding af materialer",
                  },
                ],
              },
              {
                id: "38.22",
                name: "Energiudnyttelse af affald",
                children: [
                  {
                    id: "382200",
                    name: "Energiudnyttelse af affald",
                  },
                ],
              },
              {
                id: "38.23",
                name: "Anden nyttiggørelse af affald",
                children: [
                  {
                    id: "382300",
                    name: "Anden nyttiggørelse af affald",
                  },
                ],
              },
            ],
          },
          {
            id: "38.3",
            name: "Bortskaffelse af affald uden nyttiggørelse",
            children: [
              {
                id: "38.31",
                name: "Forbrænding uden energiudnyttelse",
                children: [
                  {
                    id: "383100",
                    name: "Forbrænding uden energiudnyttelse",
                  },
                ],
              },
              {
                id: "38.32",
                name: "Deponering eller permanent oplagring",
                children: [
                  {
                    id: "383200",
                    name: "Deponering eller permanent oplagring",
                  },
                ],
              },
              {
                id: "38.33",
                name: "Anden bortskaffelse af affald",
                children: [
                  {
                    id: "383300",
                    name: "Anden bortskaffelse af affald",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "39",
        name: "Rensning af jord og grundvand og anden dekontaminering",
        children: [
          {
            id: "39.0",
            name: "Rensning af jord og grundvand og anden dekontaminering",
            children: [
              {
                id: "39.00",
                name: "Rensning af jord og grundvand og anden dekontaminering",
                children: [
                  {
                    id: "390000",
                    name: "Rensning af jord og grundvand og anden dekontaminering",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "F",
    name: "BYGGE- OG ANLÆGSAKTIVITETER",
    children: [
      {
        id: "41",
        name: "Opførelse af bygninger",
        children: [
          {
            id: "41.0",
            name: "Opførelse af bygninger",
            children: [
              {
                id: "41.00",
                name: "Opførelse af bygninger",
                children: [
                  {
                    id: "410000",
                    name: "Opførelse af bygninger",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "42",
        name: "Anlægsarbejder",
        children: [
          {
            id: "42.1",
            name: "Anlæg af veje og jernbaner",
            children: [
              {
                id: "42.11",
                name: "Anlæg af veje og motorveje",
                children: [
                  {
                    id: "421100",
                    name: "Anlæg af veje og motorveje",
                  },
                ],
              },
              {
                id: "42.12",
                name: "Anlæg af jernbaner og undergrundsbaner",
                children: [
                  {
                    id: "421200",
                    name: "Anlæg af jernbaner og undergrundsbaner",
                  },
                ],
              },
              {
                id: "42.13",
                name: "Anlæg af broer og tunneller",
                children: [
                  {
                    id: "421300",
                    name: "Anlæg af broer og tunneller",
                  },
                ],
              },
            ],
          },
          {
            id: "42.2",
            name: "Anlæg af ledningsnet",
            children: [
              {
                id: "42.21",
                name: "Anlæg af ledningsnet til væsker",
                children: [
                  {
                    id: "422100",
                    name: "Anlæg af ledningsnet til væsker",
                  },
                ],
              },
              {
                id: "42.22",
                name: "Anlæg af ledningsnet til elektricitet og telekommunikation",
                children: [
                  {
                    id: "422200",
                    name: "Anlæg af ledningsnet til elektricitet og telekommunikation",
                  },
                ],
              },
            ],
          },
          {
            id: "42.9",
            name: "Andre anlægsaktiviteter",
            children: [
              {
                id: "42.91",
                name: "Anlæg af vandveje, havne, diger, dæmninger mv.",
                children: [
                  {
                    id: "429100",
                    name: "Anlæg af vandveje, havne, diger, dæmninger mv.",
                  },
                ],
              },
              {
                id: "42.99",
                name: "Andre anlægsaktiviteter i.a.n.",
                children: [
                  {
                    id: "429900",
                    name: "Andre anlægsaktiviteter i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "43",
        name: "Specialiserede bygge- og anlægsaktiviteter",
        children: [
          {
            id: "43.1",
            name: "Nedrivning og forberedende byggepladsarbejder",
            children: [
              {
                id: "43.11",
                name: "Nedrivning",
                children: [
                  {
                    id: "431100",
                    name: "Nedrivning",
                  },
                ],
              },
              {
                id: "43.12",
                name: "Forberedende byggepladsarbejder",
                children: [
                  {
                    id: "431200",
                    name: "Forberedende byggepladsarbejder",
                  },
                ],
              },
              {
                id: "43.13",
                name: "Funderingsundersøgelser",
                children: [
                  {
                    id: "431300",
                    name: "Funderingsundersøgelser",
                  },
                ],
              },
            ],
          },
          {
            id: "43.2",
            name: "El-installation, vvs- og blikkenslageraktiviteter samt andre bygningsinstallationsaktiviteter",
            children: [
              {
                id: "43.21",
                name: "El-installation",
                children: [
                  {
                    id: "432100",
                    name: "El-installation",
                  },
                ],
              },
              {
                id: "43.22",
                name: "Installation af vvs-, varme- og klimaanlæg",
                children: [
                  {
                    id: "432200",
                    name: "Installation af vvs-, varme- og klimaanlæg",
                  },
                ],
              },
              {
                id: "43.23",
                name: "Installation af isolering",
                children: [
                  {
                    id: "432300",
                    name: "Installation af isolering",
                  },
                ],
              },
              {
                id: "43.24",
                name: "Andre bygningsinstallationsaktiviteter",
                children: [
                  {
                    id: "432400",
                    name: "Andre bygningsinstallationsaktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "43.3",
            name: "Bygningsfærdiggørelse",
            children: [
              {
                id: "43.31",
                name: "Stukkatøraktiviteter",
                children: [
                  {
                    id: "433100",
                    name: "Stukkatøraktiviteter",
                  },
                ],
              },
              {
                id: "43.32",
                name: "Tømrer- og bygningssnedkeraktiviteter",
                children: [
                  {
                    id: "433200",
                    name: "Tømrer- og bygningssnedkeraktiviteter",
                  },
                ],
              },
              {
                id: "43.33",
                name: "Udførelse af gulvbelægninger og vægbeklædning",
                children: [
                  {
                    id: "433300",
                    name: "Udførelse af gulvbelægninger og vægbeklædning",
                  },
                ],
              },
              {
                id: "43.34",
                name: "Maler- og glarmesteraktiviteter",
                children: [
                  {
                    id: "433410",
                    name: "Maleraktiviteter",
                  },
                  {
                    id: "433420",
                    name: "Glarmesteraktiviteter",
                  },
                ],
              },
              {
                id: "43.35",
                name: "Anden bygningsfærdiggørelse",
                children: [
                  {
                    id: "433500",
                    name: "Anden bygningsfærdiggørelse",
                  },
                ],
              },
            ],
          },
          {
            id: "43.4",
            name: "Specialiserede byggeaktiviteter",
            children: [
              {
                id: "43.41",
                name: "Tagdækningsaktiviteter",
                children: [
                  {
                    id: "434100",
                    name: "Tagdækningsaktiviteter",
                  },
                ],
              },
              {
                id: "43.42",
                name: "Andre specialiserede bygningsarbejder",
                children: [
                  {
                    id: "434200",
                    name: "Andre specialiserede bygningsarbejder",
                  },
                ],
              },
            ],
          },
          {
            id: "43.5",
            name: "Anlægsaktiviteter, som kræver specialisering",
            children: [
              {
                id: "43.50",
                name: "Anlægsaktiviteter, som kræver specialisering",
                children: [
                  {
                    id: "435000",
                    name: "Anlægsaktiviteter, som kræver specialisering",
                  },
                ],
              },
            ],
          },
          {
            id: "43.6",
            name: "Formidlingsaktiviteter i forbindelse med specialiserede bygge- og anlægsarbejder",
            children: [
              {
                id: "43.60",
                name: "Formidlingsaktiviteter i forbindelse med specialiserede bygge- og anlægsarbejder",
                children: [
                  {
                    id: "436000",
                    name: "Formidlingsaktiviteter i forbindelse med specialiserede bygge- og anlægsarbejder",
                  },
                ],
              },
            ],
          },
          {
            id: "43.9",
            name: "Andre byggeaktiviteter, som kræver specialisering",
            children: [
              {
                id: "43.91",
                name: "Murerarbejde",
                children: [
                  {
                    id: "439100",
                    name: "Murerarbejde",
                  },
                ],
              },
              {
                id: "43.99",
                name: "Andre specialiserede byggeaktiviteter i.a.n.",
                children: [
                  {
                    id: "439900",
                    name: "Andre specialiserede byggeaktiviteter i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "G",
    name: "ENGROSHANDEL OG DETAILHANDEL",
    children: [
      {
        id: "46",
        name: "Engroshandel",
        children: [
          {
            id: "46.1",
            name: "Engroshandel på honorar- eller kontraktbasis",
            children: [
              {
                id: "46.11",
                name: "Agenturhandel med landbrugsråvarer, levende dyr, tekstilråvarer og halvfabrikata",
                children: [
                  {
                    id: "461100",
                    name: "Agenturhandel med landbrugsråvarer, levende dyr, tekstilråvarer og halvfabrikata",
                  },
                ],
              },
              {
                id: "46.12",
                name: "Agenturhandel med brændstoffer, malme, metaller og kemiske produkter til industrien",
                children: [
                  {
                    id: "461200",
                    name: "Agenturhandel med brændstoffer, malme, metaller og kemiske produkter til industrien",
                  },
                ],
              },
              {
                id: "46.13",
                name: "Agenturhandel med tømmer og andre byggematerialer",
                children: [
                  {
                    id: "461300",
                    name: "Agenturhandel med tømmer og andre byggematerialer",
                  },
                ],
              },
              {
                id: "46.14",
                name: "Agenturhandel med maskiner, teknisk udstyr, skibe og flyvemaskiner",
                children: [
                  {
                    id: "461400",
                    name: "Agenturhandel med maskiner, teknisk udstyr, skibe og flyvemaskiner",
                  },
                ],
              },
              {
                id: "46.15",
                name: "Agenturhandel med møbler, husholdningsartikler og isenkram",
                children: [
                  {
                    id: "461500",
                    name: "Agenturhandel med møbler, husholdningsartikler og isenkram",
                  },
                ],
              },
              {
                id: "46.16",
                name: "Agenturhandel med tekstiler, beklædning, pelsværk, fodtøj og lædervarer",
                children: [
                  {
                    id: "461600",
                    name: "Agenturhandel med tekstiler, beklædning, pelsværk, fodtøj og lædervarer",
                  },
                ],
              },
              {
                id: "46.17",
                name: "Agenturhandel med føde-, drikke- og tobaksvarer",
                children: [
                  {
                    id: "461710",
                    name: "Fiskeauktioner",
                  },
                  {
                    id: "461790",
                    name: "Anden agenturhandel med føde-, drikke- og tobaksvarer",
                  },
                ],
              },
              {
                id: "46.18",
                name: "Agenturhandel med andet specialiseret varesortiment",
                children: [
                  {
                    id: "461810",
                    name: "Agenturhandel med motorcykler, biler, busser og trailere mv.",
                  },
                  {
                    id: "461890",
                    name: "Agenturhandel med specialiseret varesortiment, bortset fra køretøjer",
                  },
                ],
              },
              {
                id: "46.19",
                name: "Agenturhandel med ikke-specialiseret varesortiment",
                children: [
                  {
                    id: "461900",
                    name: "Agenturhandel med ikke-specialiseret varesortiment",
                  },
                ],
              },
            ],
          },
          {
            id: "46.2",
            name: "Engroshandel med landbrugsråvarer og levende dyr",
            children: [
              {
                id: "46.21",
                name: "Engroshandel med korn, uforarbejdet tobak, såsæd og foderstoffer",
                children: [
                  {
                    id: "462100",
                    name: "Engroshandel med korn, uforarbejdet tobak, såsæd og foderstoffer",
                  },
                ],
              },
              {
                id: "46.22",
                name: "Engroshandel med blomster og planter",
                children: [
                  {
                    id: "462200",
                    name: "Engroshandel med blomster og planter",
                  },
                ],
              },
              {
                id: "46.23",
                name: "Engroshandel med levende dyr",
                children: [
                  {
                    id: "462300",
                    name: "Engroshandel med levende dyr",
                  },
                ],
              },
              {
                id: "46.24",
                name: "Engroshandel med huder, skind og læder",
                children: [
                  {
                    id: "462400",
                    name: "Engroshandel med huder, skind og læder",
                  },
                ],
              },
            ],
          },
          {
            id: "46.3",
            name: "Engroshandel med føde-, drikke- og tobaksvarer",
            children: [
              {
                id: "46.31",
                name: "Engroshandel med frugt og grøntsager",
                children: [
                  {
                    id: "463100",
                    name: "Engroshandel med frugt og grøntsager",
                  },
                ],
              },
              {
                id: "46.32",
                name: "Engroshandel med kød, kødprodukter, fisk og fiskeprodukter",
                children: [
                  {
                    id: "463210",
                    name: "Engroshandel med kød og kødprodukter",
                  },
                  {
                    id: "463220",
                    name: "Engroshandel med fisk og fiskeprodukter",
                  },
                ],
              },
              {
                id: "46.33",
                name: "Engroshandel med mejeriprodukter, æg samt spiselige olier og fedtstoffer",
                children: [
                  {
                    id: "463300",
                    name: "Engroshandel med mejeriprodukter, æg samt spiselige olier og fedtstoffer",
                  },
                ],
              },
              {
                id: "46.34",
                name: "Engroshandel med drikkevarer",
                children: [
                  {
                    id: "463410",
                    name: "Engroshandel med øl, mineralvand, frugt- og grøntsagssaft",
                  },
                  {
                    id: "463420",
                    name: "Engroshandel med vin og spiritus",
                  },
                ],
              },
              {
                id: "46.35",
                name: "Engroshandel med tobaksvarer",
                children: [
                  {
                    id: "463500",
                    name: "Engroshandel med tobaksvarer",
                  },
                ],
              },
              {
                id: "46.36",
                name: "Engroshandel med sukker, chokolade og sukkervarer",
                children: [
                  {
                    id: "463600",
                    name: "Engroshandel med sukker, chokolade og sukkervarer",
                  },
                ],
              },
              {
                id: "46.37",
                name: "Engroshandel med kaffe, te, kakao og krydderier",
                children: [
                  {
                    id: "463700",
                    name: "Engroshandel med kaffe, te, kakao og krydderier",
                  },
                ],
              },
              {
                id: "46.38",
                name: "Engroshandel med andre fødevarer",
                children: [
                  {
                    id: "463800",
                    name: "Engroshandel med andre fødevarer",
                  },
                ],
              },
              {
                id: "46.39",
                name: "Ikke-specialiseret engroshandel med føde-, drikke- og tobaksvarer",
                children: [
                  {
                    id: "463900",
                    name: "Ikke-specialiseret engroshandel med føde-, drikke- og tobaksvarer",
                  },
                ],
              },
            ],
          },
          {
            id: "46.4",
            name: "Engroshandel med husholdningsartikler",
            children: [
              {
                id: "46.41",
                name: "Engroshandel med tekstiler",
                children: [
                  {
                    id: "464100",
                    name: "Engroshandel med tekstiler",
                  },
                ],
              },
              {
                id: "46.42",
                name: "Engroshandel med beklædning og fodtøj",
                children: [
                  {
                    id: "464210",
                    name: "Engroshandel med beklædning",
                  },
                  {
                    id: "464220",
                    name: "Engroshandel med fodtøj",
                  },
                ],
              },
              {
                id: "46.43",
                name: "Engroshandel med elektriske husholdningsartikler",
                children: [
                  {
                    id: "464310",
                    name: "Engroshandel med hvidevarer og elektriske husholdningsartikler",
                  },
                  {
                    id: "464320",
                    name: "Engroshandel med radio og tv, fotografiske og optiske artikler",
                  },
                ],
              },
              {
                id: "46.44",
                name: "Engroshandel med porcelæns- og glasvarer og rengøringsmidler",
                children: [
                  {
                    id: "464410",
                    name: "Engroshandel med porcelæns- og glasvarer",
                  },
                  {
                    id: "464420",
                    name: "Engroshandel med rengøringsmidler",
                  },
                ],
              },
              {
                id: "46.45",
                name: "Engroshandel med parfumerivarer og kosmetik",
                children: [
                  {
                    id: "464500",
                    name: "Engroshandel med parfumerivarer og kosmetik",
                  },
                ],
              },
              {
                id: "46.46",
                name: "Engroshandel med medicinalvarer og medicinske artikler",
                children: [
                  {
                    id: "464610",
                    name: "Engroshandel med medicinalvarer og sygeplejeartikler",
                  },
                  {
                    id: "464620",
                    name: "Engroshandel med læge- og hospitalsartikler",
                  },
                ],
              },
              {
                id: "46.47",
                name: "Engroshandel med møbler til bolig-, kontor- og butiksbrug, tæpper og belysningsartikler",
                children: [
                  {
                    id: "464700",
                    name: "Engroshandel med møbler til bolig-, kontor- og butiksbrug, tæpper og belysningsartikler",
                  },
                ],
              },
              {
                id: "46.48",
                name: "Engroshandel med ure og smykker",
                children: [
                  {
                    id: "464800",
                    name: "Engroshandel med ure og smykker",
                  },
                ],
              },
              {
                id: "46.49",
                name: "Engroshandel med andre husholdningsartikler",
                children: [
                  {
                    id: "464910",
                    name: "Engroshandel med cykler, sportsartikler og lystbåde",
                  },
                  {
                    id: "464920",
                    name: "Engroshandel med bøger, papir og papirvarer",
                  },
                  {
                    id: "464930",
                    name: "Engroshandel med kufferter og lædervarer",
                  },
                  {
                    id: "464990",
                    name: "Engroshandel med andre husholdningsartikler i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "46.5",
            name: "Engroshandel med informations- og kommunikationsudstyr",
            children: [
              {
                id: "46.50",
                name: "Engroshandel med informations- og kommunikationsudstyr",
                children: [
                  {
                    id: "465000",
                    name: "Engroshandel med informations- og kommunikationsudstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "46.6",
            name: "Engroshandel med andre maskiner, andet udstyr og tilbehør",
            children: [
              {
                id: "46.61",
                name: "Engroshandel med landbrugsmaskiner, -udstyr og tilbehør hertil",
                children: [
                  {
                    id: "466100",
                    name: "Engroshandel med landbrugsmaskiner, -udstyr og tilbehør hertil",
                  },
                ],
              },
              {
                id: "46.62",
                name: "Engroshandel med værktøjsmaskiner",
                children: [
                  {
                    id: "466200",
                    name: "Engroshandel med værktøjsmaskiner",
                  },
                ],
              },
              {
                id: "46.63",
                name: "Engroshandel med maskiner til minedrift og bygge- og anlægsaktiviteter",
                children: [
                  {
                    id: "466300",
                    name: "Engroshandel med maskiner til minedrift og bygge- og anlægsaktiviteter",
                  },
                ],
              },
              {
                id: "46.64",
                name: "Engroshandel med andre maskiner og andet udstyr",
                children: [
                  {
                    id: "466400",
                    name: "Engroshandel med andre maskiner og andet udstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "46.7",
            name: "Engroshandel med motorkøretøjer og motorcykler samt reservedele og tilbehør dertil",
            children: [
              {
                id: "46.71",
                name: "Engroshandel med motorkøretøjer",
                children: [
                  {
                    id: "467100",
                    name: "Engroshandel med motorkøretøjer",
                  },
                ],
              },
              {
                id: "46.72",
                name: "Engroshandel med reservedele og tilbehør til motorkøretøjer",
                children: [
                  {
                    id: "467200",
                    name: "Engroshandel med reservedele og tilbehør til motorkøretøjer",
                  },
                ],
              },
              {
                id: "46.73",
                name: "Engroshandel med motorcykler samt reservedele og tilbehør dertil",
                children: [
                  {
                    id: "467300",
                    name: "Engroshandel med motorcykler samt reservedele og tilbehør dertil",
                  },
                ],
              },
            ],
          },
          {
            id: "46.8",
            name: "Anden specialiseret engroshandel",
            children: [
              {
                id: "46.81",
                name: "Engroshandel med fast, flydende og luftformigt brændstof og lignende varer",
                children: [
                  {
                    id: "468100",
                    name: "Engroshandel med fast, flydende og luftformigt brændstof og lignende varer",
                  },
                ],
              },
              {
                id: "46.82",
                name: "Engroshandel med metaller og metalmalme",
                children: [
                  {
                    id: "468200",
                    name: "Engroshandel med metaller og metalmalme",
                  },
                ],
              },
              {
                id: "46.83",
                name: "Engroshandel med træ og byggematerialer samt sanitetsartikler",
                children: [
                  {
                    id: "468300",
                    name: "Engroshandel med træ og byggematerialer samt sanitetsartikler",
                  },
                ],
              },
              {
                id: "46.84",
                name: "Engroshandel med isenkram, varmeanlæg og tilbehør",
                children: [
                  {
                    id: "468400",
                    name: "Engroshandel med isenkram, varmeanlæg og tilbehør",
                  },
                ],
              },
              {
                id: "46.85",
                name: "Engroshandel med kemiske produkter",
                children: [
                  {
                    id: "468500",
                    name: "Engroshandel med kemiske produkter",
                  },
                ],
              },
              {
                id: "46.86",
                name: "Engroshandel med andre råvarer og halvfabrikata",
                children: [
                  {
                    id: "468600",
                    name: "Engroshandel med andre råvarer og halvfabrikata",
                  },
                ],
              },
              {
                id: "46.87",
                name: "Engroshandel med affaldsprodukter",
                children: [
                  {
                    id: "468700",
                    name: "Engroshandel med affaldsprodukter",
                  },
                ],
              },
              {
                id: "46.89",
                name: "Anden specialiseret engroshandel i.a.n.",
                children: [
                  {
                    id: "468900",
                    name: "Anden specialiseret engroshandel i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "46.9",
            name: "Ikke-specialiseret engroshandel",
            children: [
              {
                id: "46.90",
                name: "Ikke-specialiseret engroshandel",
                children: [
                  {
                    id: "469000",
                    name: "Ikke-specialiseret engroshandel",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "47",
        name: "Detailhandel",
        children: [
          {
            id: "47.1",
            name: "Ikke-specialiseret detailhandel",
            children: [
              {
                id: "47.11",
                name: "Ikke-specialiseret detailhandel med hovedvægt på føde-, drikke- eller tobaksvarer",
                children: [
                  {
                    id: "471110",
                    name: "Detailhandel med kioskvarer",
                  },
                  {
                    id: "471120",
                    name: "Detailhandel med dagligvarer i supermarkeder og købmandsbutikker",
                  },
                  {
                    id: "471130",
                    name: "Detailhandel med dagligvarer i discountsupermarkeder",
                  },
                ],
              },
              {
                id: "47.12",
                name: "Anden ikke-specialiseret detailhandel",
                children: [
                  {
                    id: "471200",
                    name: "Anden ikke-specialiseret detailhandel",
                  },
                ],
              },
            ],
          },
          {
            id: "47.2",
            name: "Detailhandel med føde-, drikke- og tobaksvarer",
            children: [
              {
                id: "47.21",
                name: "Detailhandel med frugt og grøntsager",
                children: [
                  {
                    id: "472100",
                    name: "Detailhandel med frugt og grøntsager",
                  },
                ],
              },
              {
                id: "47.22",
                name: "Detailhandel med kød og kødprodukter",
                children: [
                  {
                    id: "472200",
                    name: "Detailhandel med kød og kødprodukter",
                  },
                ],
              },
              {
                id: "47.23",
                name: "Detailhandel med fisk, krebsdyr og bløddyr",
                children: [
                  {
                    id: "472300",
                    name: "Detailhandel med fisk, krebsdyr og bløddyr",
                  },
                ],
              },
              {
                id: "47.24",
                name: "Detailhandel med bagværk og konfekture",
                children: [
                  {
                    id: "472400",
                    name: "Detailhandel med bagværk og konfekture",
                  },
                ],
              },
              {
                id: "47.25",
                name: "Detailhandel med drikkevarer",
                children: [
                  {
                    id: "472500",
                    name: "Detailhandel med drikkevarer",
                  },
                ],
              },
              {
                id: "47.26",
                name: "Detailhandel med tobaksvarer",
                children: [
                  {
                    id: "472600",
                    name: "Detailhandel med tobaksvarer",
                  },
                ],
              },
              {
                id: "47.27",
                name: "Detailhandel med andre fødevarer",
                children: [
                  {
                    id: "472700",
                    name: "Detailhandel med andre fødevarer",
                  },
                ],
              },
            ],
          },
          {
            id: "47.3",
            name: "Detailhandel med motorbrændstoffer",
            children: [
              {
                id: "47.30",
                name: "Detailhandel med motorbrændstoffer",
                children: [
                  {
                    id: "473000",
                    name: "Detailhandel med motorbrændstoffer",
                  },
                ],
              },
            ],
          },
          {
            id: "47.4",
            name: "Detailhandel med informations- og kommunikationsudstyr",
            children: [
              {
                id: "47.40",
                name: "Detailhandel med informations- og kommunikationsudstyr",
                children: [
                  {
                    id: "474000",
                    name: "Detailhandel med informations- og kommunikationsudstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "47.5",
            name: "Detailhandel med husholdningsudstyr",
            children: [
              {
                id: "47.51",
                name: "Detailhandel med tekstiler",
                children: [
                  {
                    id: "475100",
                    name: "Detailhandel med tekstiler",
                  },
                ],
              },
              {
                id: "47.52",
                name: "Detailhandel med isenkram, byggematerialer, maling og glas",
                children: [
                  {
                    id: "475210",
                    name: "Detailhandel med maling og tapet",
                  },
                  {
                    id: "475220",
                    name: "Detailhandel med byggematerialer og værktøj",
                  },
                ],
              },
              {
                id: "47.53",
                name: "Detailhandel med tæpper, vægbeklædning og gulvbelægning",
                children: [
                  {
                    id: "475300",
                    name: "Detailhandel med tæpper, vægbeklædning og gulvbelægning",
                  },
                ],
              },
              {
                id: "47.54",
                name: "Detailhandel med elektriske husholdningsapparater",
                children: [
                  {
                    id: "475400",
                    name: "Detailhandel med elektriske husholdningsapparater",
                  },
                ],
              },
              {
                id: "47.55",
                name: "Detailhandel med møbler, belysningsartikler, bordservice og andre husholdningsartikler",
                children: [
                  {
                    id: "475510",
                    name: "Detailhandel med møbler",
                  },
                  {
                    id: "475520",
                    name: "Detailhandel med bad- og køkkenelementer mv.",
                  },
                  {
                    id: "475530",
                    name: "Detailhandel med køkkenudstyr og service mv.",
                  },
                  {
                    id: "475590",
                    name: "Detailhandel med boligtekstiler, belysnings- og husholdningsartikler i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "47.6",
            name: "Detailhandel med varer til kulturelle formål og til fritid",
            children: [
              {
                id: "47.61",
                name: "Detailhandel med bøger",
                children: [
                  {
                    id: "476100",
                    name: "Detailhandel med bøger",
                  },
                ],
              },
              {
                id: "47.62",
                name: "Detailhandel med aviser og andre tidsskrifter samt kontorartikler",
                children: [
                  {
                    id: "476200",
                    name: "Detailhandel med aviser og andre tidsskrifter samt kontorartikler",
                  },
                ],
              },
              {
                id: "47.63",
                name: "Detailhandel med sportsudstyr",
                children: [
                  {
                    id: "476310",
                    name: "Detailhandel med sports- og fritidsudstyr",
                  },
                  {
                    id: "476320",
                    name: "Detailhandel med cykler",
                  },
                  {
                    id: "476330",
                    name: "Detailhandel med lystbåde og udstyr hertil",
                  },
                ],
              },
              {
                id: "47.64",
                name: "Detailhandel med spil og legetøj",
                children: [
                  {
                    id: "476400",
                    name: "Detailhandel med spil og legetøj",
                  },
                ],
              },
              {
                id: "47.69",
                name: "Detailhandel med varer til kulturelle formål og til fritid i.a.n.",
                children: [
                  {
                    id: "476910",
                    name: "Detailhandel med musikinstrumenter",
                  },
                  {
                    id: "476920",
                    name: "Detailhandel med kunst mv.",
                  },
                  {
                    id: "476990",
                    name: "Detailhandel med andre kulturelle artikler i.a.n",
                  },
                ],
              },
            ],
          },
          {
            id: "47.7",
            name: "Detailhandel med andre varer, undtagen motorkøretøjer og motorcykler",
            children: [
              {
                id: "47.71",
                name: "Detailhandel med beklædningsartikler",
                children: [
                  {
                    id: "477110",
                    name: "Detailhandel med tøj",
                  },
                  {
                    id: "477120",
                    name: "Detailhandel med baby- og børnetøj",
                  },
                ],
              },
              {
                id: "47.72",
                name: "Detailhandel med fodtøj og lædervarer",
                children: [
                  {
                    id: "477210",
                    name: "Detailhandel med fodtøj",
                  },
                  {
                    id: "477220",
                    name: "Detailhandel med lædervarer",
                  },
                ],
              },
              {
                id: "47.73",
                name: "Detailhandel med farmaceutiske produkter",
                children: [
                  {
                    id: "477300",
                    name: "Detailhandel med farmaceutiske produkter",
                  },
                ],
              },
              {
                id: "47.74",
                name: "Detailhandel med medicinske og ortopædiske artikler",
                children: [
                  {
                    id: "477410",
                    name: "Optikeraktiviteter",
                  },
                  {
                    id: "477420",
                    name: "Detailhandel med andre medicinske og ortopædiske artikler",
                  },
                ],
              },
              {
                id: "47.75",
                name: "Detailhandel med kosmetikvarer og toiletartikler",
                children: [
                  {
                    id: "477500",
                    name: "Detailhandel med kosmetikvarer og toiletartikler",
                  },
                ],
              },
              {
                id: "47.76",
                name: "Detailhandel med blomster, planter, gødningsstoffer, kæledyr samt foder til kæledyr",
                children: [
                  {
                    id: "477610",
                    name: "Detailhandel med blomster og planter",
                  },
                  {
                    id: "477620",
                    name: "Detailhandel med kæledyr og udstyr til kæledyr",
                  },
                ],
              },
              {
                id: "47.77",
                name: "Detailhandel med ure og smykker",
                children: [
                  {
                    id: "477700",
                    name: "Detailhandel med ure og smykker",
                  },
                ],
              },
              {
                id: "47.78",
                name: "Detailhandel med andre nye varer",
                children: [
                  {
                    id: "477800",
                    name: "Detailhandel med andre nye varer",
                  },
                ],
              },
              {
                id: "47.79",
                name: "Detailhandel med brugte varer",
                children: [
                  {
                    id: "477900",
                    name: "Detailhandel med brugte varer",
                  },
                ],
              },
            ],
          },
          {
            id: "47.8",
            name: "Detailhandel med motorkøretøjer og motorcykler samt reservedele og tilbehør dertil",
            children: [
              {
                id: "47.81",
                name: "Detailhandel med motorkøretøjer",
                children: [
                  {
                    id: "478100",
                    name: "Detailhandel med motorkøretøjer",
                  },
                ],
              },
              {
                id: "47.82",
                name: "Detailhandel med reservedele og tilbehør til motorkøretøjer",
                children: [
                  {
                    id: "478200",
                    name: "Detailhandel med reservedele og tilbehør til motorkøretøjer",
                  },
                ],
              },
              {
                id: "47.83",
                name: "Detailhandel med motorcykler samt reservedele og tilbehør dertil",
                children: [
                  {
                    id: "478300",
                    name: "Detailhandel med motorcykler samt reservedele og tilbehør dertil",
                  },
                ],
              },
            ],
          },
          {
            id: "47.9",
            name: "Formidlingsaktiviteter inden for detailhandel",
            children: [
              {
                id: "47.91",
                name: "Formidlingsaktiviteter inden for ikke-specialiseret detailhandel",
                children: [
                  {
                    id: "479100",
                    name: "Formidlingsaktiviteter inden for ikke-specialiseret detailhandel",
                  },
                ],
              },
              {
                id: "47.92",
                name: "Formidlingsaktiviteter inden for specialiseret detailhandel",
                children: [
                  {
                    id: "479200",
                    name: "Formidlingsaktiviteter inden for specialiseret detailhandel",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "H",
    name: "TRANSPORT OG GODSHÅNDTERING",
    children: [
      {
        id: "49",
        name: "Landtransport og rørtransport",
        children: [
          {
            id: "49.1",
            name: "Passagertransport med jernbane",
            children: [
              {
                id: "49.11",
                name: "Persontransport med regional- eller fjerntog",
                children: [
                  {
                    id: "491100",
                    name: "Persontransport med regional- eller fjerntog",
                  },
                ],
              },
              {
                id: "49.12",
                name: "Persontransport med nærbane",
                children: [
                  {
                    id: "491200",
                    name: "Persontransport med nærbane",
                  },
                ],
              },
            ],
          },
          {
            id: "49.2",
            name: "Godstransport med tog",
            children: [
              {
                id: "49.20",
                name: "Godstransport med tog",
                children: [
                  {
                    id: "492000",
                    name: "Godstransport med tog",
                  },
                ],
              },
            ],
          },
          {
            id: "49.3",
            name: "Anden landpassagertransport",
            children: [
              {
                id: "49.31",
                name: "Passagertransport ad vej med fast køreplan",
                children: [
                  {
                    id: "493100",
                    name: "Passagertransport ad vej med fast køreplan",
                  },
                ],
              },
              {
                id: "49.32",
                name: "Passagertransport ad vej uden fast køreplan",
                children: [
                  {
                    id: "493200",
                    name: "Passagertransport ad vej uden fast køreplan",
                  },
                ],
              },
              {
                id: "49.33",
                name: "Passagertransport på bestilling i køretøj med chauffør",
                children: [
                  {
                    id: "493300",
                    name: "Passagertransport på bestilling i køretøj med chauffør",
                  },
                ],
              },
              {
                id: "49.34",
                name: "Passagertransport med tovbaner og skilifter",
                children: [
                  {
                    id: "493400",
                    name: "Passagertransport med tovbaner og skilifter",
                  },
                ],
              },
              {
                id: "49.39",
                name: "Anden landpassagertransport i.a.n.",
                children: [
                  {
                    id: "493900",
                    name: "Anden landpassagertransport i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "49.4",
            name: "Vejgodstransport og flytteaktiviteter",
            children: [
              {
                id: "49.41",
                name: "Vejgodstransport",
                children: [
                  {
                    id: "494100",
                    name: "Vejgodstransport",
                  },
                ],
              },
              {
                id: "49.42",
                name: "Flytteaktiviteter",
                children: [
                  {
                    id: "494200",
                    name: "Flytteaktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "49.5",
            name: "Rørtransport",
            children: [
              {
                id: "49.50",
                name: "Rørtransport",
                children: [
                  {
                    id: "495000",
                    name: "Rørtransport",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "50",
        name: "Skibsfart",
        children: [
          {
            id: "50.1",
            name: "Sø- og kysttransport af passagerer",
            children: [
              {
                id: "50.10",
                name: "Sø- og kysttransport af passagerer",
                children: [
                  {
                    id: "501000",
                    name: "Sø- og kysttransport af passagerer",
                  },
                ],
              },
            ],
          },
          {
            id: "50.2",
            name: "Sø- og kysttransport af gods",
            children: [
              {
                id: "50.20",
                name: "Sø- og kysttransport af gods",
                children: [
                  {
                    id: "502000",
                    name: "Sø- og kysttransport af gods",
                  },
                ],
              },
            ],
          },
          {
            id: "50.3",
            name: "Transport af passagerer ad indre vandveje",
            children: [
              {
                id: "50.30",
                name: "Transport af passagerer ad indre vandveje",
                children: [
                  {
                    id: "503000",
                    name: "Transport af passagerer ad indre vandveje",
                  },
                ],
              },
            ],
          },
          {
            id: "50.4",
            name: "Transport af gods ad indre vandveje",
            children: [
              {
                id: "50.40",
                name: "Transport af gods ad indre vandveje",
                children: [
                  {
                    id: "504000",
                    name: "Transport af gods ad indre vandveje",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "51",
        name: "Luftfart",
        children: [
          {
            id: "51.1",
            name: "Lufttransport af passagerer",
            children: [
              {
                id: "51.10",
                name: "Lufttransport af passagerer",
                children: [
                  {
                    id: "511010",
                    name: "Passagertransport med rutefly",
                  },
                  {
                    id: "511020",
                    name: "Passagertransport med charter- og taxifly",
                  },
                ],
              },
            ],
          },
          {
            id: "51.2",
            name: "Lufttransport af gods og rumfart",
            children: [
              {
                id: "51.21",
                name: "Lufttransport af gods",
                children: [
                  {
                    id: "512100",
                    name: "Lufttransport af gods",
                  },
                ],
              },
              {
                id: "51.22",
                name: "Rumfart",
                children: [
                  {
                    id: "512200",
                    name: "Rumfart",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "52",
        name: "Oplagring, opbevaring og støtteaktiviteter i forbindelse med transport",
        children: [
          {
            id: "52.1",
            name: "Oplagring og opbevaring",
            children: [
              {
                id: "52.10",
                name: "Oplagring og opbevaring",
                children: [
                  {
                    id: "521000",
                    name: "Oplagring og opbevaring",
                  },
                ],
              },
            ],
          },
          {
            id: "52.2",
            name: "Støtteaktiviteter i forbindelse med transport",
            children: [
              {
                id: "52.21",
                name: "Serviceydelser i forbindelse med landtransport",
                children: [
                  {
                    id: "522110",
                    name: "Drift af stationer, godsterminaler mv.",
                  },
                  {
                    id: "522120",
                    name: "Drift af parkering og vejhjælp mv.",
                  },
                  {
                    id: "522130",
                    name: "Drift af betalingsveje, -broer og -tunneler",
                  },
                ],
              },
              {
                id: "52.22",
                name: "Serviceydelser i forbindelse med skibsfart",
                children: [
                  {
                    id: "522210",
                    name: "Drift af erhvervshavne",
                  },
                  {
                    id: "522220",
                    name: "Drift af bugserings-, bjærgnings- og redningsvæsen mv.",
                  },
                ],
              },
              {
                id: "52.23",
                name: "Serviceydelser i forbindelse med luftfart",
                children: [
                  {
                    id: "522300",
                    name: "Serviceydelser i forbindelse med luftfart",
                  },
                ],
              },
              {
                id: "52.24",
                name: "Godshåndtering",
                children: [
                  {
                    id: "522400",
                    name: "Godshåndtering",
                  },
                ],
              },
              {
                id: "52.25",
                name: "Serviceydelser i forbindelse med logistik",
                children: [
                  {
                    id: "522500",
                    name: "Serviceydelser i forbindelse med logistik",
                  },
                ],
              },
              {
                id: "52.26",
                name: "Andre støtteaktiviteter i forbindelse med transport",
                children: [
                  {
                    id: "522600",
                    name: "Andre støtteaktiviteter i forbindelse med transport",
                  },
                ],
              },
            ],
          },
          {
            id: "52.3",
            name: "Formidlingsaktiviteter inden for transport",
            children: [
              {
                id: "52.31",
                name: "Formidlingsaktiviteter inden for godstransport",
                children: [
                  {
                    id: "523100",
                    name: "Formidlingsaktiviteter inden for godstransport",
                  },
                ],
              },
              {
                id: "52.32",
                name: "Formidlingsaktiviteter inden for passagertransport",
                children: [
                  {
                    id: "523200",
                    name: "Formidlingsaktiviteter inden for passagertransport",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "53",
        name: "Post- og kuréraktiviteter",
        children: [
          {
            id: "53.1",
            name: "Postaktiviteter omfattet af forsyningspligten",
            children: [
              {
                id: "53.10",
                name: "Postaktiviteter omfattet af forsyningspligten",
                children: [
                  {
                    id: "531000",
                    name: "Postaktiviteter omfattet af forsyningspligten",
                  },
                ],
              },
            ],
          },
          {
            id: "53.2",
            name: "Andre post- og kuréraktiviteter",
            children: [
              {
                id: "53.20",
                name: "Andre post- og kuréraktiviteter",
                children: [
                  {
                    id: "532000",
                    name: "Andre post- og kuréraktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "53.3",
            name: "Formidlingsaktiviteter inden for post- og kuréraktiviteter",
            children: [
              {
                id: "53.30",
                name: "Formidlingsaktiviteter inden for post- og kuréraktiviteter",
                children: [
                  {
                    id: "533000",
                    name: "Formidlingsaktiviteter inden for post- og kuréraktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "I",
    name: "OVERNATNINGSFACILITETER OG RESTAURATIONSAKTIVITETER",
    children: [
      {
        id: "55",
        name: "Overnatningsfaciliteter",
        children: [
          {
            id: "55.1",
            name: "Drift af hoteller og lignende overnatningsfaciliteter",
            children: [
              {
                id: "55.10",
                name: "Drift af hoteller og lignende overnatningsfaciliteter",
                children: [
                  {
                    id: "551000",
                    name: "Drift af hoteller og lignende overnatningsfaciliteter",
                  },
                ],
              },
            ],
          },
          {
            id: "55.2",
            name: "Drift af ferieboliger og andre overnatningsfaciliteter til kortvarige ophold",
            children: [
              {
                id: "55.20",
                name: "Drift af ferieboliger og andre overnatningsfaciliteter til kortvarige ophold",
                children: [
                  {
                    id: "552000",
                    name: "Drift af ferieboliger og andre overnatningsfaciliteter til kortvarige ophold",
                  },
                ],
              },
            ],
          },
          {
            id: "55.3",
            name: "Drift af campingpladser",
            children: [
              {
                id: "55.30",
                name: "Drift af campingpladser",
                children: [
                  {
                    id: "553000",
                    name: "Drift af campingpladser",
                  },
                ],
              },
            ],
          },
          {
            id: "55.4",
            name: "Formidlingsaktiviteter inden for overnatningsfaciliteter",
            children: [
              {
                id: "55.40",
                name: "Formidlingsaktiviteter inden for overnatningsfaciliteter",
                children: [
                  {
                    id: "554000",
                    name: "Formidlingsaktiviteter inden for overnatningsfaciliteter",
                  },
                ],
              },
            ],
          },
          {
            id: "55.9",
            name: "Andre overnatningsfaciliteter",
            children: [
              {
                id: "55.90",
                name: "Andre overnatningsfaciliteter",
                children: [
                  {
                    id: "559000",
                    name: "Andre overnatningsfaciliteter",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "56",
        name: "Restaurationsaktiviteter",
        children: [
          {
            id: "56.1",
            name: "Drift af restauranter og mobile madboder",
            children: [
              {
                id: "56.11",
                name: "Drift af restauranter",
                children: [
                  {
                    id: "561110",
                    name: "Servering af mad i restauranter og caféer",
                  },
                  {
                    id: "561190",
                    name: "Drift af øvrige spisesteder",
                  },
                ],
              },
              {
                id: "56.12",
                name: "Drift af mobile madboder",
                children: [
                  {
                    id: "561200",
                    name: "Drift af mobile madboder",
                  },
                ],
              },
            ],
          },
          {
            id: "56.2",
            name: "Event catering, catering på kontrakt og andre restaurationsaktiviteter",
            children: [
              {
                id: "56.21",
                name: "Event catering",
                children: [
                  {
                    id: "562100",
                    name: "Event catering",
                  },
                ],
              },
              {
                id: "56.22",
                name: "Catering på kontrakt og andre restaurationsaktiviteter",
                children: [
                  {
                    id: "562200",
                    name: "Catering på kontrakt og andre restaurationsaktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "56.3",
            name: "Udskænkning af drikkevarer",
            children: [
              {
                id: "56.30",
                name: "Udskænkning af drikkevarer",
                children: [
                  {
                    id: "563010",
                    name: "Udskænkning af ikke-alkoholiske drikkevarer",
                  },
                  {
                    id: "563020",
                    name: "Udskænkning af alkoholiske drikkevarer",
                  },
                ],
              },
            ],
          },
          {
            id: "56.4",
            name: "Formidlingsaktiviteter i forbindelse med restaurationsaktiviteter",
            children: [
              {
                id: "56.40",
                name: "Formidlingsaktiviteter i forbindelse med restaurationsaktiviteter",
                children: [
                  {
                    id: "564000",
                    name: "Formidlingsaktiviteter i forbindelse med restaurationsaktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "J",
    name: "UDGIVERAKTIVITETER, RADIO- OG TV-AKTIVITETER SAMT PRODUKTION OG DISTRIBUTION AF MEDIEINDHOLD",
    children: [
      {
        id: "58",
        name: "Udgiveraktiviteter",
        children: [
          {
            id: "58.1",
            name: "Udgivelse af bøger, aviser og dagblade og andre udgiveraktiviteter, undtagen udgivelse af software",
            children: [
              {
                id: "58.11",
                name: "Udgivelse af bøger",
                children: [
                  {
                    id: "581100",
                    name: "Udgivelse af bøger",
                  },
                ],
              },
              {
                id: "58.12",
                name: "Udgivelse af aviser og dagblade",
                children: [
                  {
                    id: "581200",
                    name: "Udgivelse af aviser og dagblade",
                  },
                ],
              },
              {
                id: "58.13",
                name: "Udgivelse af ugeblade og magasiner",
                children: [
                  {
                    id: "581300",
                    name: "Udgivelse af ugeblade og magasiner",
                  },
                ],
              },
              {
                id: "58.19",
                name: "Andre udgiveraktiviteter, undtagen udgivelse af software",
                children: [
                  {
                    id: "581900",
                    name: "Andre udgiveraktiviteter, undtagen udgivelse af software",
                  },
                ],
              },
            ],
          },
          {
            id: "58.2",
            name: "Udgivelse af software",
            children: [
              {
                id: "58.21",
                name: "Udgivelse af videospil",
                children: [
                  {
                    id: "582100",
                    name: "Udgivelse af videospil",
                  },
                ],
              },
              {
                id: "58.29",
                name: "Anden udgivelse af software",
                children: [
                  {
                    id: "582900",
                    name: "Anden udgivelse af software",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "59",
        name: "Produktion af film, videoer og TV-programmer, lydoptagelser og musikudgivelser",
        children: [
          {
            id: "59.1",
            name: "Aktiviteter i forbindelse med film, videoer og TV-programmer",
            children: [
              {
                id: "59.11",
                name: "Produktion af film, videoer og TV-programmer",
                children: [
                  {
                    id: "591100",
                    name: "Produktion af film, videoer og TV-programmer",
                  },
                ],
              },
              {
                id: "59.12",
                name: "Aktiviteter efter produktion af film, videoer og TV-programmer",
                children: [
                  {
                    id: "591200",
                    name: "Aktiviteter efter produktion af film, videoer og TV-programmer",
                  },
                ],
              },
              {
                id: "59.13",
                name: "Distribution af film og videoer",
                children: [
                  {
                    id: "591300",
                    name: "Distribution af film og videoer",
                  },
                ],
              },
              {
                id: "59.14",
                name: "Fremvisning af film og andre billedmedier",
                children: [
                  {
                    id: "591400",
                    name: "Fremvisning af film og andre billedmedier",
                  },
                ],
              },
            ],
          },
          {
            id: "59.2",
            name: "Indspilning af lydoptagelser og udgivelse af musik",
            children: [
              {
                id: "59.20",
                name: "Indspilning af lydoptagelser og udgivelse af musik",
                children: [
                  {
                    id: "592000",
                    name: "Indspilning af lydoptagelser og udgivelse af musik",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "60",
        name: "Program-, radio- og tv-aktiviteter, nyhedsbureauer og anden distribution af medieindhold",
        children: [
          {
            id: "60.1",
            name: "Radioaktiviteter og distribution af lydoptagelser",
            children: [
              {
                id: "60.10",
                name: "Radioaktiviteter og distribution af lydoptagelser",
                children: [
                  {
                    id: "601000",
                    name: "Radioaktiviteter og distribution af lydoptagelser",
                  },
                ],
              },
            ],
          },
          {
            id: "60.2",
            name: "Programskabelse, udgivelse og distribution af billedoptagelser",
            children: [
              {
                id: "60.20",
                name: "Programskabelse, udgivelse og distribution af billedoptagelser",
                children: [
                  {
                    id: "602000",
                    name: "Programskabelse, udgivelse og distribution af billedoptagelser",
                  },
                ],
              },
            ],
          },
          {
            id: "60.3",
            name: "Nyhedsbureauers aktiviteter og anden distribution af medieindhold",
            children: [
              {
                id: "60.31",
                name: "Nyhedsbureauers aktiviteter",
                children: [
                  {
                    id: "603100",
                    name: "Nyhedsbureauers aktiviteter",
                  },
                ],
              },
              {
                id: "60.39",
                name: "Anden distribution af medieindhold",
                children: [
                  {
                    id: "603900",
                    name: "Anden distribution af medieindhold",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "K",
    name: "TELEKOMMUNIKATION, COMPUTERPROGRAMMERING, IT- KONSULENTAKTIVITETER, IT-INFRASTRUKTUR OG ANDRE INFORMATIONSAKTIVITETER",
    children: [
      {
        id: "61",
        name: "Telekommunikation",
        children: [
          {
            id: "61.1",
            name: "Levering af fastnetbaseret, trådløs og satellitbaseret telekommunikation",
            children: [
              {
                id: "61.10",
                name: "Levering af fastnetbaseret, trådløs og satellitbaseret telekommunikation",
                children: [
                  {
                    id: "611000",
                    name: "Levering af fastnetbaseret, trådløs og satellitbaseret telekommunikation",
                  },
                ],
              },
            ],
          },
          {
            id: "61.2",
            name: "Videresalg af telekommunikation og formidlingsaktiviteter inden for telekommunikation",
            children: [
              {
                id: "61.20",
                name: "Videresalg af telekommunikation og formidlingsaktiviteter inden for telekommunikation",
                children: [
                  {
                    id: "612000",
                    name: "Videresalg af telekommunikation og formidlingsaktiviteter inden for telekommunikation",
                  },
                ],
              },
            ],
          },
          {
            id: "61.9",
            name: "Andre telekommunikationsaktiviteter",
            children: [
              {
                id: "61.90",
                name: "Andre telekommunikationsaktiviteter",
                children: [
                  {
                    id: "619000",
                    name: "Andre telekommunikationsaktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "62",
        name: "Computerprogrammering, konsulentbistand vedrørende informationsteknologi og lignende aktiviteter",
        children: [
          {
            id: "62.1",
            name: "Computerprogrammering",
            children: [
              {
                id: "62.10",
                name: "Computerprogrammering",
                children: [
                  {
                    id: "621000",
                    name: "Computerprogrammering",
                  },
                ],
              },
            ],
          },
          {
            id: "62.2",
            name: "Konsulentbistand vedrørende informationsteknologi og forvaltning af it-faciliteter",
            children: [
              {
                id: "62.20",
                name: "Konsulentbistand vedrørende informationsteknologi og forvaltning af it-faciliteter",
                children: [
                  {
                    id: "622000",
                    name: "Konsulentbistand vedrørende informationsteknologi og forvaltning af it-faciliteter",
                  },
                ],
              },
            ],
          },
          {
            id: "62.9",
            name: "Andre IT- og computerserviceaktiviteter",
            children: [
              {
                id: "62.90",
                name: "Andre IT- og computerserviceaktiviteter",
                children: [
                  {
                    id: "629000",
                    name: "Andre IT- og computerserviceaktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "63",
        name: "It-infrastruktur, databehandling, hosting og andre informationsaktiviteter",
        children: [
          {
            id: "63.1",
            name: "Aktiviteter i forbindelse med it-infrastruktur, databehandling, hosting o.lign.",
            children: [
              {
                id: "63.10",
                name: "Aktiviteter i forbindelse med it-infrastruktur, databehandling, hosting o.lign.",
                children: [
                  {
                    id: "631000",
                    name: "Aktiviteter i forbindelse med it-infrastruktur, databehandling, hosting o.lign.",
                  },
                ],
              },
            ],
          },
          {
            id: "63.9",
            name: "Drift af portaler til internettet og andre informationsaktiviteter",
            children: [
              {
                id: "63.91",
                name: "Drift af portaler til internettet",
                children: [
                  {
                    id: "639100",
                    name: "Drift af portaler til internettet",
                  },
                ],
              },
              {
                id: "63.92",
                name: "Andre informationsaktiviteter",
                children: [
                  {
                    id: "639200",
                    name: "Andre informationsaktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "L",
    name: "PENGEINSTITUT- OG FINANSAKTIVITETER, FORSIKRING",
    children: [
      {
        id: "64",
        name: "Pengeinstitut- og finansieringsaktiviteter undtagen forsikring og pensionsforsikring",
        children: [
          {
            id: "64.1",
            name: "Pengeinstitutters aktiviteter",
            children: [
              {
                id: "64.11",
                name: "Centralbankers aktiviteter",
                children: [
                  {
                    id: "641100",
                    name: "Centralbankers aktiviteter",
                  },
                ],
              },
              {
                id: "64.19",
                name: "Andre pengeinstitutters aktiviteter",
                children: [
                  {
                    id: "641900",
                    name: "Andre pengeinstitutters aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "64.2",
            name: "Holding- og gennemstrømningsselskabers aktiviteter",
            children: [
              {
                id: "64.21",
                name: "Holdingselskabers aktiviteter",
                children: [
                  {
                    id: "642110",
                    name: "Finansielle holdingselskaber",
                  },
                  {
                    id: "642120",
                    name: "Ikke-finansielle holdingselskaber",
                  },
                  {
                    id: "642130",
                    name: "Gennemløbsholdingselskaber",
                  },
                ],
              },
              {
                id: "64.22",
                name: "Finansielle conduiters aktiviteter",
                children: [
                  {
                    id: "642200",
                    name: "Finansielle conduiters aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "64.3",
            name: "Investeringsforeningers, investeringsselskabers og lignende enheders aktiviteter",
            children: [
              {
                id: "64.31",
                name: "Investeringsfondes aktiviteter",
                children: [
                  {
                    id: "643110",
                    name: "Pengemarkedsfondes aktiviteter",
                  },
                  {
                    id: "643120",
                    name: "Andre investeringsfondes aktiviteter",
                  },
                ],
              },
              {
                id: "64.32",
                name: "Trusters aktiviteter",
                children: [
                  {
                    id: "643200",
                    name: "Trusters aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "64.9",
            name: "Anden finansiel formidling, undtagen forsikring og pensionsforsikring",
            children: [
              {
                id: "64.91",
                name: "Finansiel leasing",
                children: [
                  {
                    id: "649100",
                    name: "Finansiel leasing",
                  },
                ],
              },
              {
                id: "64.92",
                name: "Anden kreditformidling",
                children: [
                  {
                    id: "649210",
                    name: "Realkreditinstitutters aktiviteter",
                  },
                  {
                    id: "649220",
                    name: "Andre kreditinstitutters aktiviteter",
                  },
                  {
                    id: "649230",
                    name: "Andre kreditselskabers aktiviteter",
                  },
                ],
              },
              {
                id: "64.99",
                name: "Anden finansiel formidling, undtagen forsikring og pensionsforsikring i.a.n.",
                children: [
                  {
                    id: "649910",
                    name: "Investering for egen regning",
                  },
                  {
                    id: "649990",
                    name: "Anden finansiel formidling i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "65",
        name: "Forsikring, genforsikring og pensionsforsikring, undtagen lovpligtig socialforsikring",
        children: [
          {
            id: "65.1",
            name: "Forsikring",
            children: [
              {
                id: "65.11",
                name: "Livsforsikring",
                children: [
                  {
                    id: "651100",
                    name: "Livsforsikring",
                  },
                ],
              },
              {
                id: "65.12",
                name: "Anden forsikring",
                children: [
                  {
                    id: "651200",
                    name: "Anden forsikring",
                  },
                ],
              },
            ],
          },
          {
            id: "65.2",
            name: "Genforsikring",
            children: [
              {
                id: "65.20",
                name: "Genforsikring",
                children: [
                  {
                    id: "652000",
                    name: "Genforsikring",
                  },
                ],
              },
            ],
          },
          {
            id: "65.3",
            name: "Pensionsforsikring",
            children: [
              {
                id: "65.30",
                name: "Pensionsforsikring",
                children: [
                  {
                    id: "653010",
                    name: "Pensionskassers aktiviteter",
                  },
                  {
                    id: "653020",
                    name: "Anden pensionsforsikring",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "66",
        name: "Aktiviteter i forbindelse med finansielle tjenesteydelser og forsikringsaktiviteter",
        children: [
          {
            id: "66.1",
            name: "Aktiviteter i forbindelse med finansielle tjenesteydelser, undtagen forsikring og pensionsforsikring",
            children: [
              {
                id: "66.11",
                name: "Forvaltning af kapitalmarkeder",
                children: [
                  {
                    id: "661100",
                    name: "Forvaltning af kapitalmarkeder",
                  },
                ],
              },
              {
                id: "66.12",
                name: "Værdipapir- og varemægling",
                children: [
                  {
                    id: "661200",
                    name: "Værdipapir- og varemægling",
                  },
                ],
              },
              {
                id: "66.19",
                name: "Andre aktiviteter i forbindelse med finansielle tjenesteydelser, undtagen forsikring og pensionsforsikring",
                children: [
                  {
                    id: "661900",
                    name: "Andre aktiviteter i forbindelse med finansielle tjenesteydelser, undtagen forsikring og pensionsforsikring",
                  },
                ],
              },
            ],
          },
          {
            id: "66.2",
            name: "Aktiviteter i forbindelse med forsikring og pensionsforsikring",
            children: [
              {
                id: "66.21",
                name: "Risiko- og skadesvurdering",
                children: [
                  {
                    id: "662100",
                    name: "Risiko- og skadesvurdering",
                  },
                ],
              },
              {
                id: "66.22",
                name: "Forsikringsagenters og forsikringsmægleres aktiviteter",
                children: [
                  {
                    id: "662200",
                    name: "Forsikringsagenters og forsikringsmægleres aktiviteter",
                  },
                ],
              },
              {
                id: "66.29",
                name: "Aktiviteter i forbindelse med forsikring og pensionsforsikring i.a.n.",
                children: [
                  {
                    id: "662900",
                    name: "Aktiviteter i forbindelse med forsikring og pensionsforsikring i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "66.3",
            name: "Formueforvaltning",
            children: [
              {
                id: "66.30",
                name: "Formueforvaltning",
                children: [
                  {
                    id: "663000",
                    name: "Formueforvaltning",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "M",
    name: "AKTIVITETER I FORBINDELSE MED FAST EJENDOM",
    children: [
      {
        id: "68",
        name: "Aktiviteter i forbindelse med fast ejendom",
        children: [
          {
            id: "68.1",
            name: "Aktiviteter i forbindelse med egen fast ejendom og gennemførelse af byggeprojekter",
            children: [
              {
                id: "68.11",
                name: "Køb og salg af egen fast ejendom",
                children: [
                  {
                    id: "681100",
                    name: "Køb og salg af egen fast ejendom",
                  },
                ],
              },
              {
                id: "68.12",
                name: "Gennemførelse af byggeprojekter",
                children: [
                  {
                    id: "681200",
                    name: "Gennemførelse af byggeprojekter",
                  },
                ],
              },
            ],
          },
          {
            id: "68.2",
            name: "Udlejning af og aktiviteter i forbindelse med egen eller leaset fast ejendom",
            children: [
              {
                id: "68.20",
                name: "Udlejning af og aktiviteter i forbindelse med egen eller leaset fast ejendom",
                children: [
                  {
                    id: "682010",
                    name: "Udlejning af almennyttige boliger",
                  },
                  {
                    id: "682020",
                    name: "Udlejning af private andelsboliger",
                  },
                  {
                    id: "682030",
                    name: "Anden udlejning af boliger",
                  },
                  {
                    id: "682040",
                    name: "Udlejning af erhvervsejendomme",
                  },
                ],
              },
            ],
          },
          {
            id: "68.3",
            name: "Aktiviteter i forbindelse med fast ejendom på honorar- eller kontraktbasis",
            children: [
              {
                id: "68.31",
                name: "Formidlingsaktiviteter i forbindelse med fast ejendom",
                children: [
                  {
                    id: "683110",
                    name: "Ejendomsmægleres aktiviteter",
                  },
                  {
                    id: "683120",
                    name: "Boliganvisning",
                  },
                ],
              },
              {
                id: "68.32",
                name: "Andre aktiviteter i forbindelse med fast ejendom på honorar- eller kontraktbasis",
                children: [
                  {
                    id: "683210",
                    name: "Administration af fast ejendom på kontraktbasis",
                  },
                  {
                    id: "683220",
                    name: "Drift af ejerforeninger",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "N",
    name: "LIBERALE, VIDENSKABELIGE OG TEKNISKE AKTIVITETER",
    children: [
      {
        id: "69",
        name: "Juridiske og regnskabsmæssige aktiviteter",
        children: [
          {
            id: "69.1",
            name: "Juridiske aktiviteter",
            children: [
              {
                id: "69.10",
                name: "Juridiske aktiviteter",
                children: [
                  {
                    id: "691000",
                    name: "Juridiske aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "69.2",
            name: "Bogføring og revision",
            children: [
              {
                id: "69.20",
                name: "Bogføring og revision",
                children: [
                  {
                    id: "692000",
                    name: "Bogføring og revision",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "70",
        name: "Hovedsæders aktiviteter og virksomhedsrådgivning",
        children: [
          {
            id: "70.1",
            name: "Hovedsæders aktiviteter",
            children: [
              {
                id: "70.10",
                name: "Hovedsæders aktiviteter",
                children: [
                  {
                    id: "701010",
                    name: "Ikke-finansielle hovedsæders aktiviteter",
                  },
                  {
                    id: "701020",
                    name: "Finansielle hovedsæders aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "70.2",
            name: "Virksomhedsrådgivning og anden ledelsesrådgivning",
            children: [
              {
                id: "70.20",
                name: "Virksomhedsrådgivning og anden ledelsesrådgivning",
                children: [
                  {
                    id: "702000",
                    name: "Virksomhedsrådgivning og anden ledelsesrådgivning",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "71",
        name: "Arkitekt- og ingeniøraktiviteter",
        children: [
          {
            id: "71.1",
            name: "Arkitekt- og ingeniøraktiviteter og lignende teknisk rådgivning",
            children: [
              {
                id: "71.11",
                name: "Arkitekters aktiviteter",
                children: [
                  {
                    id: "711100",
                    name: "Arkitekters aktiviteter",
                  },
                ],
              },
              {
                id: "71.12",
                name: "Ingeniøraktiviteter og lignende teknisk rådgivning",
                children: [
                  {
                    id: "711210",
                    name: "Rådgivende ingeniøraktiviteter inden for byggeri og anlægsarbejder",
                  },
                  {
                    id: "711220",
                    name: "Rådgivende ingeniøraktiviteter inden for produktions- og maskinteknik",
                  },
                  {
                    id: "711230",
                    name: "Rådgivende ingeniøraktiviteter inden for færdige fabriksanlæg",
                  },
                  {
                    id: "711240",
                    name: "Geologiske undersøgelser og prospektering, landinspektører mv.",
                  },
                  {
                    id: "711290",
                    name: "Anden teknisk rådgivning",
                  },
                ],
              },
            ],
          },
          {
            id: "71.2",
            name: "Teknisk afprøvning og analyse",
            children: [
              {
                id: "71.20",
                name: "Teknisk afprøvning og analyse",
                children: [
                  {
                    id: "712010",
                    name: "Kontrol af levnedsmidler",
                  },
                  {
                    id: "712020",
                    name: "Teknisk afprøvning og kontrol",
                  },
                  {
                    id: "712090",
                    name: "Anden måling og teknisk analyse",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "72",
        name: "Videnskabelig forskning og udvikling",
        children: [
          {
            id: "72.1",
            name: "Forskning og eksperimentel udvikling inden for naturvidenskab og teknik",
            children: [
              {
                id: "72.10",
                name: "Forskning og eksperimentel udvikling inden for naturvidenskab og teknik",
                children: [
                  {
                    id: "721000",
                    name: "Forskning og eksperimentel udvikling inden for naturvidenskab og teknik",
                  },
                ],
              },
            ],
          },
          {
            id: "72.2",
            name: "Forskning og eksperimentel udvikling inden for samfundsvidenskab og humanistiske videnskaber",
            children: [
              {
                id: "72.20",
                name: "Forskning og eksperimentel udvikling inden for samfundsvidenskab og humanistiske videnskaber",
                children: [
                  {
                    id: "722000",
                    name: "Forskning og eksperimentel udvikling inden for samfundsvidenskab og humanistiske videnskaber",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "73",
        name: "Reklameaktiviteter, markedsanalyse og public relations",
        children: [
          {
            id: "73.1",
            name: "Reklameaktiviteter",
            children: [
              {
                id: "73.11",
                name: "Reklamebureauers aktiviteter",
                children: [
                  {
                    id: "731110",
                    name: "Planlægning og design af reklamekampagner",
                  },
                  {
                    id: "731190",
                    name: "Andre reklameaktiviteter",
                  },
                ],
              },
              {
                id: "73.12",
                name: "Indrykning af reklamer i medier",
                children: [
                  {
                    id: "731200",
                    name: "Indrykning af reklamer i medier",
                  },
                ],
              },
            ],
          },
          {
            id: "73.2",
            name: "Markedsanalyse og offentlig meningsmåling",
            children: [
              {
                id: "73.20",
                name: "Markedsanalyse og offentlig meningsmåling",
                children: [
                  {
                    id: "732000",
                    name: "Markedsanalyse og offentlig meningsmåling",
                  },
                ],
              },
            ],
          },
          {
            id: "73.3",
            name: "Public relations og kommunikation",
            children: [
              {
                id: "73.30",
                name: "Public relations og kommunikation",
                children: [
                  {
                    id: "733000",
                    name: "Public relations og kommunikation",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "74",
        name: "Andre liberale, videnskabelige og tekniske aktiviteter",
        children: [
          {
            id: "74.1",
            name: "Specialiseret designarbejde",
            children: [
              {
                id: "74.11",
                name: "Industrielt design og modedesign",
                children: [
                  {
                    id: "741100",
                    name: "Industrielt design og modedesign",
                  },
                ],
              },
              {
                id: "74.12",
                name: "Grafisk design og visuel kommunikation",
                children: [
                  {
                    id: "741200",
                    name: "Grafisk design og visuel kommunikation",
                  },
                ],
              },
              {
                id: "74.13",
                name: "Indretningsaktiviteter",
                children: [
                  {
                    id: "741300",
                    name: "Indretningsaktiviteter",
                  },
                ],
              },
              {
                id: "74.14",
                name: "Andet specialiseret designarbejde",
                children: [
                  {
                    id: "741400",
                    name: "Andet specialiseret designarbejde",
                  },
                ],
              },
            ],
          },
          {
            id: "74.2",
            name: "Fotografiske aktiviteter",
            children: [
              {
                id: "74.20",
                name: "Fotografiske aktiviteter",
                children: [
                  {
                    id: "742000",
                    name: "Fotografiske aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "74.3",
            name: "Oversættelse og tolkning",
            children: [
              {
                id: "74.30",
                name: "Oversættelse og tolkning",
                children: [
                  {
                    id: "743000",
                    name: "Oversættelse og tolkning",
                  },
                ],
              },
            ],
          },
          {
            id: "74.9",
            name: "Andre liberale, videnskabelige og tekniske aktiviteter i.a.n.",
            children: [
              {
                id: "74.91",
                name: "Patentbureauers aktiviteter og tjenesteydelser i forbindelse med markedsføring",
                children: [
                  {
                    id: "749100",
                    name: "Patentbureauers aktiviteter og tjenesteydelser i forbindelse med markedsføring",
                  },
                ],
              },
              {
                id: "74.99",
                name: "Alle andre liberale, videnskabelige og tekniske aktiviteter i.a.n.",
                children: [
                  {
                    id: "749910",
                    name: "Landbrugskonsulenters aktiviteter",
                  },
                  {
                    id: "749990",
                    name: "Andre liberale, videnskabelige og tekniske tjenesteydelser i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "75",
        name: "Dyrlægers aktiviteter",
        children: [
          {
            id: "75.0",
            name: "Dyrlægers aktiviteter",
            children: [
              {
                id: "75.00",
                name: "Dyrlægers aktiviteter",
                children: [
                  {
                    id: "750000",
                    name: "Dyrlægers aktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "O",
    name: "ADMINISTRATIONS- OG STØTTEAKTIVITETER",
    children: [
      {
        id: "77",
        name: "Udlejning og leasing",
        children: [
          {
            id: "77.1",
            name: "Udlejning og leasing af motorkøretøjer",
            children: [
              {
                id: "77.11",
                name: "Udlejning og leasing af biler og lette motorkøretøjer",
                children: [
                  {
                    id: "771100",
                    name: "Udlejning og leasing af biler og lette motorkøretøjer",
                  },
                ],
              },
              {
                id: "77.12",
                name: "Udlejning og leasing af lastbiler",
                children: [
                  {
                    id: "771200",
                    name: "Udlejning og leasing af lastbiler",
                  },
                ],
              },
            ],
          },
          {
            id: "77.2",
            name: "Udlejning og leasing af varer til personlig brug og husholdningsbrug",
            children: [
              {
                id: "77.21",
                name: "Udlejning og leasing af varer til fritid og sport",
                children: [
                  {
                    id: "772100",
                    name: "Udlejning og leasing af varer til fritid og sport",
                  },
                ],
              },
              {
                id: "77.22",
                name: "Udlejning og leasing af andre varer til personlig brug og husholdningsbrug",
                children: [
                  {
                    id: "772200",
                    name: "Udlejning og leasing af andre varer til personlig brug og husholdningsbrug",
                  },
                ],
              },
            ],
          },
          {
            id: "77.3",
            name: "Udlejning og leasing af andet materiel, udstyr og andre materielle aktiver",
            children: [
              {
                id: "77.31",
                name: "Udlejning og leasing af landbrugsmaskiner og -udstyr",
                children: [
                  {
                    id: "773100",
                    name: "Udlejning og leasing af landbrugsmaskiner og -udstyr",
                  },
                ],
              },
              {
                id: "77.32",
                name: "Udlejning og leasing af entreprenørmateriel",
                children: [
                  {
                    id: "773200",
                    name: "Udlejning og leasing af entreprenørmateriel",
                  },
                ],
              },
              {
                id: "77.33",
                name: "Udlejning og leasing af kontormaskiner og -udstyr og computere",
                children: [
                  {
                    id: "773300",
                    name: "Udlejning og leasing af kontormaskiner og -udstyr og computere",
                  },
                ],
              },
              {
                id: "77.34",
                name: "Udlejning og leasing af skibe og både",
                children: [
                  {
                    id: "773400",
                    name: "Udlejning og leasing af skibe og både",
                  },
                ],
              },
              {
                id: "77.35",
                name: "Udlejning og leasing af luftfartøjer",
                children: [
                  {
                    id: "773500",
                    name: "Udlejning og leasing af luftfartøjer",
                  },
                ],
              },
              {
                id: "77.39",
                name: "Udlejning og leasing af andet materiel, udstyr og andre materielle aktiver i.a.n.",
                children: [
                  {
                    id: "773910",
                    name: "Udlejning og leasing af andet materiel, udstyr og andre materielle aktiver til events",
                  },
                  {
                    id: "773990",
                    name: "Udlejning og leasing af andet materiel, udstyr og andre materielle aktiver, bortset fra til events",
                  },
                ],
              },
            ],
          },
          {
            id: "77.4",
            name: "Leasing af intellektuelle ejendomsrettigheder og lignende produkter, dog ikke ophavsretsbeskyttede værker",
            children: [
              {
                id: "77.40",
                name: "Leasing af intellektuelle ejendomsrettigheder og lignende produkter, dog ikke ophavsretsbeskyttede værker",
                children: [
                  {
                    id: "774000",
                    name: "Leasing af intellektuelle ejendomsrettigheder og lignende produkter, dog ikke ophavsretsbeskyttede værker",
                  },
                ],
              },
            ],
          },
          {
            id: "77.5",
            name: "Formidlingsaktiviteter inden for udlejning og leasing af materielle aktiver og ikke-finansielle immaterielle aktiver",
            children: [
              {
                id: "77.51",
                name: "Formidlingsaktiviteter inden for udlejning og leasing af biler, autocampere og påhængsvogne",
                children: [
                  {
                    id: "775100",
                    name: "Formidlingsaktiviteter inden for udlejning og leasing af biler, autocampere og påhængsvogne",
                  },
                ],
              },
              {
                id: "77.52",
                name: "Formidlingsaktiviteter inden for udlejning og leasing af andre materielle aktiver og andre ikke-finansielle immaterielle aktiver",
                children: [
                  {
                    id: "775200",
                    name: "Formidlingsaktiviteter inden for udlejning og leasing af andre materielle aktiver og andre ikke-finansielle immaterielle aktiver",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "78",
        name: "Arbejdsformidling",
        children: [
          {
            id: "78.1",
            name: "Arbejdsformidlingskontorers aktiviteter",
            children: [
              {
                id: "78.10",
                name: "Arbejdsformidlingskontorers aktiviteter",
                children: [
                  {
                    id: "781000",
                    name: "Arbejdsformidlingskontorers aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "78.2",
            name: "Vikarbureauers aktiviteter og anden personaleformidling",
            children: [
              {
                id: "78.20",
                name: "Vikarbureauers aktiviteter og anden personaleformidling",
                children: [
                  {
                    id: "782000",
                    name: "Vikarbureauers aktiviteter og anden personaleformidling",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "79",
        name: "Rejsebureauers og rejsearrangørers aktiviteter og andre reservationstjenesteydelser og tjenesteydelser i forbindelse hermed",
        children: [
          {
            id: "79.1",
            name: "Rejsebureauers og rejsearrangørers aktiviteter",
            children: [
              {
                id: "79.11",
                name: "Rejsebureauers aktiviteter",
                children: [
                  {
                    id: "791100",
                    name: "Rejsebureauers aktiviteter",
                  },
                ],
              },
              {
                id: "79.12",
                name: "Rejsearrangørers aktiviteter",
                children: [
                  {
                    id: "791200",
                    name: "Rejsearrangørers aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "79.9",
            name: "Andre reservationstjenesteydelser og tjenesteydelser i forbindelse hermed",
            children: [
              {
                id: "79.90",
                name: "Andre reservationstjenesteydelser og tjenesteydelser i forbindelse hermed",
                children: [
                  {
                    id: "799000",
                    name: "Andre reservationstjenesteydelser og tjenesteydelser i forbindelse hermed",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "80",
        name: "Efterforskning og vagt- og sikkerhedsaktiviteter",
        children: [
          {
            id: "80.0",
            name: "Efterforskning og vagt- og sikkerhedsaktiviteter",
            children: [
              {
                id: "80.01",
                name: "Efterforskning og private vagt- og sikkerhedsaktiviteter",
                children: [
                  {
                    id: "800100",
                    name: "Efterforskning og private vagt- og sikkerhedsaktiviteter",
                  },
                ],
              },
              {
                id: "80.09",
                name: "Vagt- og sikkerhedsaktiviteter i.a.n.",
                children: [
                  {
                    id: "800900",
                    name: "Vagt- og sikkerhedsaktiviteter i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "81",
        name: "Serviceydelser i forbindelse med ejendomme samt landskabspleje",
        children: [
          {
            id: "81.1",
            name: "Levering af kombinerede hjælpetjenester i forbindelse med drift af fast ejendom",
            children: [
              {
                id: "81.10",
                name: "Levering af kombinerede hjælpetjenester i forbindelse med drift af fast ejendom",
                children: [
                  {
                    id: "811000",
                    name: "Levering af kombinerede hjælpetjenester i forbindelse med drift af fast ejendom",
                  },
                ],
              },
            ],
          },
          {
            id: "81.2",
            name: "Rengøring",
            children: [
              {
                id: "81.21",
                name: "Almindelig rengøring i bygninger",
                children: [
                  {
                    id: "812100",
                    name: "Almindelig rengøring i bygninger",
                  },
                ],
              },
              {
                id: "81.22",
                name: "Anden rengøring af bygninger og rengøring af erhvervslokaler",
                children: [
                  {
                    id: "812210",
                    name: "Vinduespolering",
                  },
                  {
                    id: "812220",
                    name: "Skorstensfejning",
                  },
                  {
                    id: "812290",
                    name: "Anden rengøring af bygninger og rengøring af erhvervslokaler i.a.n.",
                  },
                ],
              },
              {
                id: "81.23",
                name: "Anden rengøring",
                children: [
                  {
                    id: "812300",
                    name: "Anden rengøring",
                  },
                ],
              },
            ],
          },
          {
            id: "81.3",
            name: "Landskabspleje",
            children: [
              {
                id: "81.30",
                name: "Landskabspleje",
                children: [
                  {
                    id: "813000",
                    name: "Landskabspleje",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "82",
        name: "Administrations- og kontorservice samt andre forretningsserviceaktiviteter",
        children: [
          {
            id: "82.1",
            name: "Administrations- og kontorserviceaktiviteter",
            children: [
              {
                id: "82.10",
                name: "Administrations- og kontorserviceaktiviteter",
                children: [
                  {
                    id: "821000",
                    name: "Administrations- og kontorserviceaktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "82.2",
            name: "Drift af callcentre",
            children: [
              {
                id: "82.20",
                name: "Drift af callcentre",
                children: [
                  {
                    id: "822000",
                    name: "Drift af callcentre",
                  },
                ],
              },
            ],
          },
          {
            id: "82.3",
            name: "Organisering af kongresser, messer og udstillinger",
            children: [
              {
                id: "82.30",
                name: "Organisering af kongresser, messer og udstillinger",
                children: [
                  {
                    id: "823000",
                    name: "Organisering af kongresser, messer og udstillinger",
                  },
                ],
              },
            ],
          },
          {
            id: "82.4",
            name: "Formidlingsaktiviteter inden for forretningsservice i.a.n.",
            children: [
              {
                id: "82.40",
                name: "Formidlingsaktiviteter inden for forretningsservice i.a.n.",
                children: [
                  {
                    id: "824000",
                    name: "Formidlingsaktiviteter inden for forretningsservice i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "82.9",
            name: "Forretningsserviceaktiviteter i.a.n.",
            children: [
              {
                id: "82.91",
                name: "Inkassoaktiviteter og kreditoplysning",
                children: [
                  {
                    id: "829100",
                    name: "Inkassoaktiviteter og kreditoplysning",
                  },
                ],
              },
              {
                id: "82.92",
                name: "Pakkeriaktiviteter",
                children: [
                  {
                    id: "829200",
                    name: "Pakkeriaktiviteter",
                  },
                ],
              },
              {
                id: "82.99",
                name: "Andre forretningsserviceaktiviteter i.a.n.",
                children: [
                  {
                    id: "829900",
                    name: "Andre forretningsserviceaktiviteter i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "P",
    name: "OFFENTLIG FORVALTNING OG FORSVAR",
    children: [
      {
        id: "84",
        name: "Offentlig forvaltning og forsvar",
        children: [
          {
            id: "84.1",
            name: "Forvaltning af staten og den økonomiske, sociale og miljømæssige politik",
            children: [
              {
                id: "84.11",
                name: "Generelle offentlige forvaltningsaktiviteter",
                children: [
                  {
                    id: "841100",
                    name: "Generelle offentlige forvaltningsaktiviteter",
                  },
                ],
              },
              {
                id: "84.12",
                name: "Administration af sundhedsvæsen, undervisning, kultur og sociale forhold",
                children: [
                  {
                    id: "841200",
                    name: "Administration af sundhedsvæsen, undervisning, kultur og sociale forhold",
                  },
                ],
              },
              {
                id: "84.13",
                name: "Administration af og bidrag til erhvervsfremme",
                children: [
                  {
                    id: "841300",
                    name: "Administration af og bidrag til erhvervsfremme",
                  },
                ],
              },
            ],
          },
          {
            id: "84.2",
            name: "Levering af tjenesteydelser til samfundet som helhed",
            children: [
              {
                id: "84.21",
                name: "Udenrigsanliggender",
                children: [
                  {
                    id: "842100",
                    name: "Udenrigsanliggender",
                  },
                ],
              },
              {
                id: "84.22",
                name: "Forsvarets aktiviteter",
                children: [
                  {
                    id: "842200",
                    name: "Forsvarets aktiviteter",
                  },
                ],
              },
              {
                id: "84.23",
                name: "Rets- og fængselsvæsenets aktiviteter",
                children: [
                  {
                    id: "842300",
                    name: "Rets- og fængselsvæsenets aktiviteter",
                  },
                ],
              },
              {
                id: "84.24",
                name: "Aktiviteter i forbindelse med offentlig sikkerhed og orden",
                children: [
                  {
                    id: "842400",
                    name: "Aktiviteter i forbindelse med offentlig sikkerhed og orden",
                  },
                ],
              },
              {
                id: "84.25",
                name: "Brandvæsenets aktiviteter",
                children: [
                  {
                    id: "842500",
                    name: "Brandvæsenets aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "84.3",
            name: "Aktiviteter inden for lovpligtig socialsikring",
            children: [
              {
                id: "84.30",
                name: "Aktiviteter inden for lovpligtig socialsikring",
                children: [
                  {
                    id: "843000",
                    name: "Aktiviteter inden for lovpligtig socialsikring",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "Q",
    name: "UNDERVISNING",
    children: [
      {
        id: "85",
        name: "Undervisning",
        children: [
          {
            id: "85.1",
            name: "Førskoleundervisning",
            children: [
              {
                id: "85.10",
                name: "Førskoleundervisning",
                children: [
                  {
                    id: "851000",
                    name: "Førskoleundervisning",
                  },
                ],
              },
            ],
          },
          {
            id: "85.2",
            name: "Undervisning på grundskoler",
            children: [
              {
                id: "85.20",
                name: "Undervisning på grundskoler",
                children: [
                  {
                    id: "852010",
                    name: "Undervisning på almene grundskoler",
                  },
                  {
                    id: "852020",
                    name: "Undervisning på specialskoler for børn med funktionsnedsættelser",
                  },
                ],
              },
            ],
          },
          {
            id: "85.3",
            name: "Undervisning på gymnasier og erhvervsfaglige skoler samt videregående uddannelse, ikke på universitetsniveau",
            children: [
              {
                id: "85.31",
                name: "Undervisning på gymnasier, studenterkurser o.lign.",
                children: [
                  {
                    id: "853110",
                    name: "Undervisning på ungdoms- og efterskoler",
                  },
                  {
                    id: "853120",
                    name: "Undervisning på gymnasier, studenter- og HF-kurser",
                  },
                ],
              },
              {
                id: "85.32",
                name: "Undervisning på erhvervsfaglige skoler",
                children: [
                  {
                    id: "853200",
                    name: "Undervisning på erhvervsfaglige skoler",
                  },
                ],
              },
              {
                id: "85.33",
                name: "Videregående uddannelse, ikke på universitetsniveau",
                children: [
                  {
                    id: "853300",
                    name: "Videregående uddannelse, ikke på universitetsniveau",
                  },
                ],
              },
            ],
          },
          {
            id: "85.4",
            name: "Videregående uddannelse på universitetsniveau",
            children: [
              {
                id: "85.40",
                name: "Videregående uddannelse på universitetsniveau",
                children: [
                  {
                    id: "854000",
                    name: "Videregående uddannelse på universitetsniveau",
                  },
                ],
              },
            ],
          },
          {
            id: "85.5",
            name: "Anden undervisning",
            children: [
              {
                id: "85.51",
                name: "Undervisning inden for sport og fritid",
                children: [
                  {
                    id: "855100",
                    name: "Undervisning inden for sport og fritid",
                  },
                ],
              },
              {
                id: "85.52",
                name: "Undervisning i kulturelle discipliner",
                children: [
                  {
                    id: "855200",
                    name: "Undervisning i kulturelle discipliner",
                  },
                ],
              },
              {
                id: "85.53",
                name: "Drift af køreskoler",
                children: [
                  {
                    id: "855300",
                    name: "Drift af køreskoler",
                  },
                ],
              },
              {
                id: "85.59",
                name: "Anden undervisning i.a.n.",
                children: [
                  {
                    id: "855900",
                    name: "Anden undervisning i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "85.6",
            name: "Levering af hjælpeydelser i forbindelse med undervisning",
            children: [
              {
                id: "85.61",
                name: "Formidlingsaktiviteter i forbindelse med kurser og undervisere",
                children: [
                  {
                    id: "856100",
                    name: "Formidlingsaktiviteter i forbindelse med kurser og undervisere",
                  },
                ],
              },
              {
                id: "85.69",
                name: "Levering af hjælpeydelser i forbindelse med undervisning i.a.n.",
                children: [
                  {
                    id: "856900",
                    name: "Levering af hjælpeydelser i forbindelse med undervisning i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "R",
    name: "SUNDHEDS- OG SOCIALVÆSENETS AKTIVITETER",
    children: [
      {
        id: "86",
        name: "Sundhedsvæsenets aktiviteter",
        children: [
          {
            id: "86.1",
            name: "Hospitalsaktviteter",
            children: [
              {
                id: "86.10",
                name: "Hospitalsaktviteter",
                children: [
                  {
                    id: "861000",
                    name: "Hospitalsaktviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "86.2",
            name: "Læger og tandlægers aktiviteter",
            children: [
              {
                id: "86.21",
                name: "Alment praktiserende lægers aktiviteter",
                children: [
                  {
                    id: "862100",
                    name: "Alment praktiserende lægers aktiviteter",
                  },
                ],
              },
              {
                id: "86.22",
                name: "Speciallægers aktiviteter",
                children: [
                  {
                    id: "862200",
                    name: "Speciallægers aktiviteter",
                  },
                ],
              },
              {
                id: "86.23",
                name: "Tandlægers aktiviteter",
                children: [
                  {
                    id: "862300",
                    name: "Tandlægers aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "86.9",
            name: "Andre aktiviteter inden for sundhedsvæsen",
            children: [
              {
                id: "86.91",
                name: "Billeddiagnostiske undersøgelser og medicinske laboratorieaktiviteter",
                children: [
                  {
                    id: "869100",
                    name: "Billeddiagnostiske undersøgelser og medicinske laboratorieaktiviteter",
                  },
                ],
              },
              {
                id: "86.92",
                name: "Patienttransport med ambulance",
                children: [
                  {
                    id: "869200",
                    name: "Patienttransport med ambulance",
                  },
                ],
              },
              {
                id: "86.93",
                name: "Psykologisk og psykoterapeutisk rådgivning",
                children: [
                  {
                    id: "869300",
                    name: "Psykologisk og psykoterapeutisk rådgivning",
                  },
                ],
              },
              {
                id: "86.94",
                name: "Sundhedspleje, hjemmesygepleje, jordemoderaktiviteter mv.",
                children: [
                  {
                    id: "869400",
                    name: "Sundhedspleje, hjemmesygepleje, jordemoderaktiviteter mv.",
                  },
                ],
              },
              {
                id: "86.95",
                name: "Fysio- og ergoterapi",
                children: [
                  {
                    id: "869500",
                    name: "Fysio- og ergoterapi",
                  },
                ],
              },
              {
                id: "86.96",
                name: "Traditionelle, komplementære og alternative behandlingsformer",
                children: [
                  {
                    id: "869600",
                    name: "Traditionelle, komplementære og alternative behandlingsformer",
                  },
                ],
              },
              {
                id: "86.97",
                name: "Formidlingsaktiviteter inden for lægers og tandlægers aktiviteter samt sundhedsvæsen i øvrigt",
                children: [
                  {
                    id: "869700",
                    name: "Formidlingsaktiviteter inden for lægers og tandlægers aktiviteter samt sundhedsvæsen i øvrigt",
                  },
                ],
              },
              {
                id: "86.99",
                name: "Drift af sundhedsvæsen i øvrigt i.a.n.",
                children: [
                  {
                    id: "869900",
                    name: "Drift af sundhedsvæsen i øvrigt i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "87",
        name: "Aktiviteter i forbindelse med institutionsophold",
        children: [
          {
            id: "87.1",
            name: "Aktiviteter i forbindelse med institutionsophold med sygepleje",
            children: [
              {
                id: "87.10",
                name: "Aktiviteter i forbindelse med institutionsophold med sygepleje",
                children: [
                  {
                    id: "871010",
                    name: "Drift af plejehjem",
                  },
                  {
                    id: "871020",
                    name: "Institutionsophold med sygepleje i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "87.2",
            name: "Aktiviteter i forbindelse med institutionsophold for personer med psykiske funktionsnedsættelser eller stofmisbrug",
            children: [
              {
                id: "87.20",
                name: "Aktiviteter i forbindelse med institutionsophold for personer med psykiske funktionsnedsættelser eller stofmisbrug",
                children: [
                  {
                    id: "872010",
                    name: "Drift af døgninstitutioner for personer med psykiske handicap",
                  },
                  {
                    id: "872020",
                    name: "Drift af behandlingshjem for stofmisbrugere og alkoholskadede",
                  },
                ],
              },
            ],
          },
          {
            id: "87.3",
            name: "Aktiviteter i forbindelse med institutionsophold for ældre eller personer med fysiske funktionsnedsættelser",
            children: [
              {
                id: "87.30",
                name: "Aktiviteter i forbindelse med institutionsophold for ældre eller personer med fysiske funktionsnedsættelser",
                children: [
                  {
                    id: "873010",
                    name: "Drift af døgninstitutioner for personer med fysisk handicap",
                  },
                  {
                    id: "873020",
                    name: "Drift af beskyttede boliger o. lign.",
                  },
                ],
              },
            ],
          },
          {
            id: "87.9",
            name: "Andre aktiviteter i forbindelse med institutionsophold",
            children: [
              {
                id: "87.91",
                name: "Formidlingsaktiviteter i forbindelse med institutionsophold",
                children: [
                  {
                    id: "879100",
                    name: "Formidlingsaktiviteter i forbindelse med institutionsophold",
                  },
                ],
              },
              {
                id: "87.99",
                name: "Andre aktiviteter i forbindelse med institutionsophold i.a.n.",
                children: [
                  {
                    id: "879910",
                    name: "Drift af døgninstitutioner for børn og unge",
                  },
                  {
                    id: "879920",
                    name: "Familiepleje",
                  },
                  {
                    id: "879930",
                    name: "Drift af flygtninge- og asylcentre",
                  },
                  {
                    id: "879990",
                    name: "Drift af andre former for institutionsophold",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "88",
        name: "Sociale foranstaltninger uden institutionsophold",
        children: [
          {
            id: "88.1",
            name: "Sociale foranstaltninger uden institutionsophold for ældre eller personer med funktionsnedsættelser",
            children: [
              {
                id: "88.10",
                name: "Sociale foranstaltninger uden institutionsophold for ældre eller personer med funktionsnedsættelser",
                children: [
                  {
                    id: "881010",
                    name: "Drift af hjemmehjælp",
                  },
                  {
                    id: "881020",
                    name: "Drift af dagcentre mv.",
                  },
                  {
                    id: "881030",
                    name: "Drift af revalideringsinstitutioner",
                  },
                ],
              },
            ],
          },
          {
            id: "88.9",
            name: "Andre sociale foranstaltninger uden institutionsophold",
            children: [
              {
                id: "88.91",
                name: "Børnedagpleje",
                children: [
                  {
                    id: "889110",
                    name: "Drift af dagpleje",
                  },
                  {
                    id: "889120",
                    name: "Drift af vuggestuer",
                  },
                  {
                    id: "889130",
                    name: "Drift af børnehaver",
                  },
                  {
                    id: "889140",
                    name: "Drift af skolefritidsordninger og fritidshjem",
                  },
                  {
                    id: "889150",
                    name: "Drift af aldersintegrerede institutioner",
                  },
                  {
                    id: "889160",
                    name: "Drift af fritids- og ungdomsklubber",
                  },
                ],
              },
              {
                id: "88.99",
                name: "Andre sociale foranstaltninger uden institutionsophold i.a.n.",
                children: [
                  {
                    id: "889910",
                    name: "Støtteaktiviteter relateret til sygdomsbekæmpende, sociale og velgørende formål",
                  },
                  {
                    id: "889920",
                    name: "Aktiviteter til støtte for flygtninge- og katastrofeofre mv.",
                  },
                  {
                    id: "889990",
                    name: "Andre sociale støtte- og rådgivningsaktiviteter uden institutionsophold",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "S",
    name: "KULTUR, SPORT OG FRITIDSAKTIVITETER",
    children: [
      {
        id: "90",
        name: "Kunstnerisk skaben og aktiviteter i forbindelse med scenekunst",
        children: [
          {
            id: "90.1",
            name: "Kunstnerisk skaben",
            children: [
              {
                id: "90.11",
                name: "Litteratur- og musikkomposition",
                children: [
                  {
                    id: "901100",
                    name: "Litteratur- og musikkomposition",
                  },
                ],
              },
              {
                id: "90.12",
                name: "Billedkunstnerisk skaben",
                children: [
                  {
                    id: "901200",
                    name: "Billedkunstnerisk skaben",
                  },
                ],
              },
              {
                id: "90.13",
                name: "Anden kunstnerisk skaben",
                children: [
                  {
                    id: "901300",
                    name: "Anden kunstnerisk skaben",
                  },
                ],
              },
            ],
          },
          {
            id: "90.2",
            name: "Aktiviteter i forbindelse med scenekunst",
            children: [
              {
                id: "90.20",
                name: "Aktiviteter i forbindelse med scenekunst",
                children: [
                  {
                    id: "902010",
                    name: "Teater- og koncertproduktioner",
                  },
                  {
                    id: "902020",
                    name: "Selvstændigt udøvende scenekunstnere",
                  },
                ],
              },
            ],
          },
          {
            id: "90.3",
            name: "Levering af serviceydelser i forbindelse med kunstnerisk skaben og scenekunst",
            children: [
              {
                id: "90.31",
                name: "Drift af teater- og koncertsale, kulturhuse mv.",
                children: [
                  {
                    id: "903100",
                    name: "Drift af teater- og koncertsale, kulturhuse mv.",
                  },
                ],
              },
              {
                id: "90.39",
                name: "Levering af andre serviceydelser i forbindelse med kunstnerisk skaben og scenekunst",
                children: [
                  {
                    id: "903910",
                    name: "Teknisk planlægning, levering, opsætning og betjening af udstyr til events",
                  },
                  {
                    id: "903920",
                    name: "Levering af andre serviceydelser i forbindelse med kunstnerisk skaben og scenekunst i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "91",
        name: "Biblioteks-, arkiv- og museumsaktiviteter samt andre kulturelle aktiviteter",
        children: [
          {
            id: "91.1",
            name: "Biblioteks- og arkivaktiviteter",
            children: [
              {
                id: "91.11",
                name: "Biblioteksaktiviteter",
                children: [
                  {
                    id: "911100",
                    name: "Biblioteksaktiviteter",
                  },
                ],
              },
              {
                id: "91.12",
                name: "Arkivaktiviteter",
                children: [
                  {
                    id: "911200",
                    name: "Arkivaktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "91.2",
            name: "Museumsaktiviteter og aktiviteter i forbindelse med samlinger, fortidsminder, mindesmærker mv.",
            children: [
              {
                id: "91.21",
                name: "Museumsaktiviteter og aktiviteter i forbindelse med samlinger",
                children: [
                  {
                    id: "912100",
                    name: "Museumsaktiviteter og aktiviteter i forbindelse med samlinger",
                  },
                ],
              },
              {
                id: "91.22",
                name: "Drift og bevarelse af fortidsminder, mindesmærker mv.",
                children: [
                  {
                    id: "912200",
                    name: "Drift og bevarelse af fortidsminder, mindesmærker mv.",
                  },
                ],
              },
            ],
          },
          {
            id: "91.3",
            name: "Konservering, restaurering og andre serviceydelser inden for kulturarv",
            children: [
              {
                id: "91.30",
                name: "Konservering, restaurering og andre serviceydelser inden for kulturarv",
                children: [
                  {
                    id: "913000",
                    name: "Konservering, restaurering og andre serviceydelser inden for kulturarv",
                  },
                ],
              },
            ],
          },
          {
            id: "91.4",
            name: "Drift af botaniske og zoologiske haver og naturreservater",
            children: [
              {
                id: "91.41",
                name: "Drift af botaniske og zoologiske haver",
                children: [
                  {
                    id: "914100",
                    name: "Drift af botaniske og zoologiske haver",
                  },
                ],
              },
              {
                id: "91.42",
                name: "Drift af naturreservater",
                children: [
                  {
                    id: "914200",
                    name: "Drift af naturreservater",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "92",
        name: "Lotteri- og andre spilleaktiviteter",
        children: [
          {
            id: "92.0",
            name: "Lotteri- og andre spilleaktiviteter",
            children: [
              {
                id: "92.00",
                name: "Lotteri- og andre spilleaktiviteter",
                children: [
                  {
                    id: "920000",
                    name: "Lotteri- og andre spilleaktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "93",
        name: "Sportsaktiviteter, forlystelser og fritidsaktiviteter",
        children: [
          {
            id: "93.1",
            name: "Sportsaktiviteter",
            children: [
              {
                id: "93.11",
                name: "Drift af sportsanlæg",
                children: [
                  {
                    id: "931100",
                    name: "Drift af sportsanlæg",
                  },
                ],
              },
              {
                id: "93.12",
                name: "Drift af sportsklubber",
                children: [
                  {
                    id: "931200",
                    name: "Drift af sportsklubber",
                  },
                ],
              },
              {
                id: "93.13",
                name: "Drift af fitnesscentre",
                children: [
                  {
                    id: "931300",
                    name: "Drift af fitnesscentre",
                  },
                ],
              },
              {
                id: "93.19",
                name: "Sportsaktiviteter i.a.n.",
                children: [
                  {
                    id: "931900",
                    name: "Sportsaktiviteter i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "93.2",
            name: "Forlystelser og fritidsaktiviteter",
            children: [
              {
                id: "93.21",
                name: "Drift af forlystelsesparker o.lign.",
                children: [
                  {
                    id: "932100",
                    name: "Drift af forlystelsesparker o.lign.",
                  },
                ],
              },
              {
                id: "93.29",
                name: "Forlystelser og fritidsaktiviteter i.a.n.",
                children: [
                  {
                    id: "932910",
                    name: "Drift af lystbådehavne",
                  },
                  {
                    id: "932990",
                    name: "Drift af andre forlystelser og fritidsaktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "T",
    name: "ANDRE SERVICEYDELSER",
    children: [
      {
        id: "94",
        name: "Organisationers og foreningers aktiviteter",
        children: [
          {
            id: "94.1",
            name: "Erhvervs- og arbejdsgiverorganisationers og faglige sammenslutningers aktiviteter",
            children: [
              {
                id: "94.11",
                name: "Erhvervs- og arbejdsgiverorganisationers aktiviteter",
                children: [
                  {
                    id: "941100",
                    name: "Erhvervs- og arbejdsgiverorganisationers aktiviteter",
                  },
                ],
              },
              {
                id: "94.12",
                name: "Faglige sammenslutningers aktiviteter",
                children: [
                  {
                    id: "941200",
                    name: "Faglige sammenslutningers aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "94.2",
            name: "Fagforeningers aktiviteter",
            children: [
              {
                id: "94.20",
                name: "Fagforeningers aktiviteter",
                children: [
                  {
                    id: "942000",
                    name: "Fagforeningers aktiviteter",
                  },
                ],
              },
            ],
          },
          {
            id: "94.9",
            name: "Andre organisationers og foreningers aktiviteter",
            children: [
              {
                id: "94.91",
                name: "Religiøse institutioners og foreningers aktiviteter",
                children: [
                  {
                    id: "949100",
                    name: "Religiøse institutioners og foreningers aktiviteter",
                  },
                ],
              },
              {
                id: "94.92",
                name: "Politiske partiers aktiviteter",
                children: [
                  {
                    id: "949200",
                    name: "Politiske partiers aktiviteter",
                  },
                ],
              },
              {
                id: "94.99",
                name: "Andre organisationers og foreningers aktiviteter i.a.n.",
                children: [
                  {
                    id: "949900",
                    name: "Andre organisationers og foreningers aktiviteter i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "95",
        name: "Reparation og vedligeholdelse af computere, varer til personlig brug og husholdningsbrug samt motorkøretøjer og motorcykler",
        children: [
          {
            id: "95.1",
            name: "Reparation og vedligeholdelse af computere og kommunikationsudstyr",
            children: [
              {
                id: "95.10",
                name: "Reparation og vedligeholdelse af computere og kommunikationsudstyr",
                children: [
                  {
                    id: "951000",
                    name: "Reparation og vedligeholdelse af computere og kommunikationsudstyr",
                  },
                ],
              },
            ],
          },
          {
            id: "95.2",
            name: "Reparation og vedligeholdelse af varer til personlig brug og husholdningsbrug",
            children: [
              {
                id: "95.21",
                name: "Reparation og vedligeholdelse af forbrugerelektronik",
                children: [
                  {
                    id: "952100",
                    name: "Reparation og vedligeholdelse af forbrugerelektronik",
                  },
                ],
              },
              {
                id: "95.22",
                name: "Reparation og vedligeholdelse af husholdningsapparater og redskaber til hus og have",
                children: [
                  {
                    id: "952200",
                    name: "Reparation og vedligeholdelse af husholdningsapparater og redskaber til hus og have",
                  },
                ],
              },
              {
                id: "95.23",
                name: "Reparation og vedligeholdelse af fodtøj og lædervarer",
                children: [
                  {
                    id: "952300",
                    name: "Reparation og vedligeholdelse af fodtøj og lædervarer",
                  },
                ],
              },
              {
                id: "95.24",
                name: "Reparation og vedligeholdelse af møbler og boligudstyr",
                children: [
                  {
                    id: "952400",
                    name: "Reparation og vedligeholdelse af møbler og boligudstyr",
                  },
                ],
              },
              {
                id: "95.25",
                name: "Reparation og vedligeholdelse af ure og smykker",
                children: [
                  {
                    id: "952500",
                    name: "Reparation og vedligeholdelse af ure og smykker",
                  },
                ],
              },
              {
                id: "95.29",
                name: "Reparation og vedligeholdelse af varer til personlig brug og husholdningsbrug i.a.n.",
                children: [
                  {
                    id: "952900",
                    name: "Reparation og vedligeholdelse af varer til personlig brug og husholdningsbrug i.a.n.",
                  },
                ],
              },
            ],
          },
          {
            id: "95.3",
            name: "Reparation og vedligeholdelse af motorkøretøjer og motorcykler",
            children: [
              {
                id: "95.31",
                name: "Reparation og vedligeholdelse af motorkøretøjer",
                children: [
                  {
                    id: "953110",
                    name: "Dækservice",
                  },
                  {
                    id: "953120",
                    name: "Reparation og lakering af karosseri samt undervognsbehandling",
                  },
                  {
                    id: "953190",
                    name: "Reparation og vedligeholdelse af motorkøretøjer i.a.n.",
                  },
                ],
              },
              {
                id: "95.32",
                name: "Reparation og vedligeholdelse af motorcykler",
                children: [
                  {
                    id: "953200",
                    name: "Reparation og vedligeholdelse af motorcykler",
                  },
                ],
              },
            ],
          },
          {
            id: "95.4",
            name: "Formidlingsaktiviteter i forbindelse med reparation og vedligeholdelse af computere, varer til personlig brug og husholdningsbrug samt motorkøretøjer og motorcykler",
            children: [
              {
                id: "95.40",
                name: "Formidlingsaktiviteter i forbindelse med reparation og vedligeholdelse af computere, varer til personlig brug og husholdningsbrug samt motorkøretøjer og motorcykler",
                children: [
                  {
                    id: "954000",
                    name: "Formidlingsaktiviteter i forbindelse med reparation og vedligeholdelse af computere, varer til personlig brug og husholdningsbrug samt motorkøretøjer og motorcykler",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "96",
        name: "Personlige serviceydelser",
        children: [
          {
            id: "96.1",
            name: "Vask og rensning af tekstiler og pelsværk",
            children: [
              {
                id: "96.10",
                name: "Vask og rensning af tekstiler og pelsværk",
                children: [
                  {
                    id: "961010",
                    name: "Drift af erhvervs- og institutionsvaskerier",
                  },
                  {
                    id: "961020",
                    name: "Drift af renserier og selvbetjeningsvaskerier mv.",
                  },
                ],
              },
            ],
          },
          {
            id: "96.2",
            name: "Drift af frisør- og skønhedssaloner, dagspa mv.",
            children: [
              {
                id: "96.21",
                name: "Drift af frisør- og barbersaloner",
                children: [
                  {
                    id: "962100",
                    name: "Drift af frisør- og barbersaloner",
                  },
                ],
              },
              {
                id: "96.22",
                name: "Skønhedspleje og anden skønhedsbehandling",
                children: [
                  {
                    id: "962200",
                    name: "Skønhedspleje og anden skønhedsbehandling",
                  },
                ],
              },
              {
                id: "96.23",
                name: "Drift af dagspa, saunaer og dampbade",
                children: [
                  {
                    id: "962300",
                    name: "Drift af dagspa, saunaer og dampbade",
                  },
                ],
              },
            ],
          },
          {
            id: "96.3",
            name: "Drift af bedemandsforretninger og begravelsesvæsen",
            children: [
              {
                id: "96.30",
                name: "Drift af bedemandsforretninger og begravelsesvæsen",
                children: [
                  {
                    id: "963000",
                    name: "Drift af bedemandsforretninger og begravelsesvæsen",
                  },
                ],
              },
            ],
          },
          {
            id: "96.4",
            name: "Formidlingsaktiviteter inden for personlige serviceydelser",
            children: [
              {
                id: "96.40",
                name: "Formidlingsaktiviteter inden for personlige serviceydelser",
                children: [
                  {
                    id: "964000",
                    name: "Formidlingsaktiviteter inden for personlige serviceydelser",
                  },
                ],
              },
            ],
          },
          {
            id: "96.9",
            name: "Andre personlige serviceydelser",
            children: [
              {
                id: "96.91",
                name: "Levering af personlige serviceydelser i hjemmet",
                children: [
                  {
                    id: "969100",
                    name: "Levering af personlige serviceydelser i hjemmet",
                  },
                ],
              },
              {
                id: "96.99",
                name: "Andre personlige serviceydelser i.a.n.",
                children: [
                  {
                    id: "969900",
                    name: "Andre personlige serviceydelser i.a.n.",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "U",
    name: "AKTIVITETER I HUSHOLDNINGER MED ANSAT MEDHJÆLP OG HUSHOLDNINGERS PRODUKTION AF UDIFFERENTIEREDE VARER OG TJENESTEYDELSER TIL EGET BRUG",
    children: [
      {
        id: "97",
        name: "Aktiviteter i husholdninger med ansat medhjælp",
        children: [
          {
            id: "97.0",
            name: "Aktiviteter i husholdninger med ansat medhjælp",
            children: [
              {
                id: "97.00",
                name: "Aktiviteter i husholdninger med ansat medhjælp",
                children: [
                  {
                    id: "970000",
                    name: "Aktiviteter i husholdninger med ansat medhjælp",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: "98",
        name: "Private husholdningers produktion af udifferentierede varer og tjenesteydelser til eget brug",
        children: [
          {
            id: "98.1",
            name: "Private husholdningers produktion af udifferentierede varer til eget brug",
            children: [
              {
                id: "98.10",
                name: "Private husholdningers produktion af udifferentierede varer til eget brug",
                children: [
                  {
                    id: "981000",
                    name: "Private husholdningers produktion af udifferentierede varer til eget brug",
                  },
                ],
              },
            ],
          },
          {
            id: "98.2",
            name: "Private husholdningers produktion af udifferentierede tjenesteydelser til eget brug",
            children: [
              {
                id: "98.20",
                name: "Private husholdningers produktion af udifferentierede tjenesteydelser til eget brug",
                children: [
                  {
                    id: "982000",
                    name: "Private husholdningers produktion af udifferentierede tjenesteydelser til eget brug",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "V",
    name: "EKSTERRITORIALE ORGANISATIONERS OG ORGANERS AKTIVITETER",
    children: [
      {
        id: "99",
        name: "Eksterritoriale organisationers og organers aktiviteter",
        children: [
          {
            id: "99.0",
            name: "Eksterritoriale organisationers og organers aktiviteter",
            children: [
              {
                id: "99.00",
                name: "Eksterritoriale organisationers og organers aktiviteter",
                children: [
                  {
                    id: "990010",
                    name: "Ambassaders eksterritoriale aktivitet",
                  },
                  {
                    id: "990020",
                    name: "Andre eksterritoriale organisationers og organers aktiviteter",
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
